import React, { Component } from "react";
import moment from 'moment';
import momenttimezone from 'moment-timezone';
import AgGrid from "../../../common/components/ag-grid/ag-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cloneDeep } from "lodash";
import { faFileExport, faEye, faChartBar } from '@fortawesome/free-solid-svg-icons';
import { inject, observer } from "mobx-react";
import * as XLSX from 'xlsx-js-style'
import NominationScreenStore from '../store/nomination-data-store';
import NOMINATION_EXCEL_STYLES from "./nomination-excel-styles";
import {
    WholeNumberFormat, MultiLineFormat, MultiLineOutage, DecimalFormatter1Digit,
    PercentageFormatter, PercentageFormatter1Digits, PercentageFormatter2Digits
} from "../../../common/NumberFormatter";
import { CopyDownEditor } from "./CopyDownEditor";
import SmartMultiSelectClearable from '../../../common/SmartMultiSelectClearable';
import { DateTimeFormatter } from '../../../common/DateFormatterWithZone';
import { AppConstants } from '../../../common/APIConstants';
import footerJson from '../services/nomination-footer.json';
import { Form, Modal } from "react-bootstrap";
import WindowedSelect from "react-windowed-select";
import { getColumnDefitions } from "../utils/columns";
import { getFooters, getHiddenGridsData, getOlds, getOpens, getPinnedBottoms, getRows } from "../utils/hidden-grids";
import { exportMultipleGrids } from "../export-all";

import '../component/nomination-component.scss';
@inject("NominationScreenStore", "CommonStore")
@observer
class NominationData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nmntnData: [],
            gridOptions: {
                context: {
                    componentParent: this
                },
                headerHeight: 45, suppressScrollOnNewData: true,
                onPasteStart: (event) => this.onPasteStart(event),
                onPasteEnd: (event) => this.onPasteEnd(event),
                onCellValueChanged: (event) => this.onCellValueChanged(event),
                onRowDataChanged: (event) => this.onRowDataChanged(event),
                getContextMenuItems: this.getContextMenuItems,
                processCellFromClipboard: (p) => this.processCellFromClipboard(p),
                defaultColDef: {
                    autoHeight: true, resizable: true, wrapHeaderText: true,
                    autoHeaderHeight: true, suppressMovable: true
                },
                frameworkComponents: {
                    dateFormatter: DateTimeFormatter,
                    numberFormatter: WholeNumberFormat,
                    decimalFormatter: DecimalFormatter1Digit,
                    multiLineFormat: MultiLineFormat,
                    multiLineOutage: MultiLineOutage,
                    multiSelectCellEditor: SmartMultiSelectClearable,
                    copyDownEditor: CopyDownEditor,
                    percentageWholeFormatter: PercentageFormatter,
                    percentageFormatter: PercentageFormatter1Digits,
                    percentage2Formatter: PercentageFormatter2Digits
                },
                excelStyles: NOMINATION_EXCEL_STYLES
            },
            butaneGridOptions: {
                context: {
                    componentParent: this
                },
                headerHeight: 45, suppressScrollOnNewData: true,
                getContextMenuItems: this.getContextMenuItems,
                defaultColDef: {
                    autoHeight: true, resizable: true, wrapHeaderText: true,
                    autoHeaderHeight: true, suppressMovable: true
                },
                frameworkComponents: {
                    dateFormatter: DateTimeFormatter,
                    numberFormatter: WholeNumberFormat,
                    decimalFormatter: DecimalFormatter1Digit,
                    multiLineFormat: MultiLineFormat,
                    multiLineOutage: MultiLineOutage,
                    multiSelectCellEditor: SmartMultiSelectClearable,
                    copyDownEditor: CopyDownEditor,
                    percentageWholeFormatter: PercentageFormatter,
                    percentageFormatter: PercentageFormatter1Digits,
                    percentage2Formatter: PercentageFormatter2Digits
                },
                excelStyles: NOMINATION_EXCEL_STYLES
            },
            isoButaneGridOptions: {
                context: {
                    componentParent: this
                },
                headerHeight: 45, suppressScrollOnNewData: true,
                defaultColDef: {
                    autoHeight: true, resizable: true, wrapHeaderText: true,
                    autoHeaderHeight: true, suppressMovable: true
                },
                frameworkComponents: {
                    dateFormatter: DateTimeFormatter,
                    numberFormatter: WholeNumberFormat,
                    decimalFormatter: DecimalFormatter1Digit,
                    multiLineFormat: MultiLineFormat,
                    multiLineOutage: MultiLineOutage,
                    multiSelectCellEditor: SmartMultiSelectClearable,
                    copyDownEditor: CopyDownEditor,
                    percentageWholeFormatter: PercentageFormatter,
                    percentageFormatter: PercentageFormatter1Digits,
                    percentage2Formatter: PercentageFormatter2Digits
                },
                excelStyles: NOMINATION_EXCEL_STYLES
            },
            normalButaneGridOptions: {
                context: {
                    componentParent: this
                },
                headerHeight: 45, suppressScrollOnNewData: true,
                defaultColDef: {
                    autoHeight: true, resizable: true, wrapHeaderText: true,
                    autoHeaderHeight: true, suppressMovable: true
                },
                frameworkComponents: {
                    dateFormatter: DateTimeFormatter,
                    numberFormatter: WholeNumberFormat,
                    decimalFormatter: DecimalFormatter1Digit,
                    multiLineFormat: MultiLineFormat,
                    multiLineOutage: MultiLineOutage,
                    multiSelectCellEditor: SmartMultiSelectClearable,
                    copyDownEditor: CopyDownEditor,
                    percentageWholeFormatter: PercentageFormatter,
                    percentageFormatter: PercentageFormatter1Digits,
                    percentage2Formatter: PercentageFormatter2Digits
                },
                excelStyles: NOMINATION_EXCEL_STYLES
            },
            propaneGridOptions: {
                context: {
                    componentParent: this
                },
                headerHeight: 45, suppressScrollOnNewData: true,
                defaultColDef: {
                    autoHeight: true, resizable: true, wrapHeaderText: true,
                    autoHeaderHeight: true, suppressMovable: true
                },
                frameworkComponents: {
                    dateFormatter: DateTimeFormatter,
                    numberFormatter: WholeNumberFormat,
                    decimalFormatter: DecimalFormatter1Digit,
                    multiLineFormat: MultiLineFormat,
                    multiLineOutage: MultiLineOutage,
                    multiSelectCellEditor: SmartMultiSelectClearable,
                    copyDownEditor: CopyDownEditor,
                    percentageWholeFormatter: PercentageFormatter,
                    percentageFormatter: PercentageFormatter1Digits,
                    percentage2Formatter: PercentageFormatter2Digits
                },
                excelStyles: NOMINATION_EXCEL_STYLES
            },
            condensateGridOptions: {
                context: {
                    componentParent: this
                },
                headerHeight: 45, suppressScrollOnNewData: true,
                defaultColDef: {
                    autoHeight: true, resizable: true, wrapHeaderText: true,
                    autoHeaderHeight: true, suppressMovable: true
                },
                frameworkComponents: {
                    dateFormatter: DateTimeFormatter,
                    numberFormatter: WholeNumberFormat,
                    decimalFormatter: DecimalFormatter1Digit,
                    multiLineFormat: MultiLineFormat,
                    multiLineOutage: MultiLineOutage,
                    multiSelectCellEditor: SmartMultiSelectClearable,
                    copyDownEditor: CopyDownEditor,
                    percentageWholeFormatter: PercentageFormatter,
                    percentageFormatter: PercentageFormatter1Digits,
                    percentage2Formatter: PercentageFormatter2Digits
                },
                excelStyles: NOMINATION_EXCEL_STYLES
            },
            nmntnColDef: [], nominationRole: props.nominationRole,
            userName: props.userName, displayName: props.displayName, gridIndicators: '',
            assetViewON: false, overUnderViewON: false, nominationViewON: false, actualsViewON: false,
            footerItems: [], enableSave: false, editData: {}, isAuditPopup: false,
            auditData: [], auditOptions: [], auditSelectedField: { label: '', value: '' },
            isDirty: false, isPasting: false, openAttribute: 0,
            butaneData: [],
            condensateData: [],
            isoButaneData: [],
            normalButaneData: [],
            propaneData: [],
            butaneColDefs: [],
            condensateColDefs: [],
            isoButaneColDefs: [],
            normalButaneColDefs: [],
            propaneColDefs: [],
        };
    }
    async onRowDataChanged(params) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;

        if (this.state.isDirty) {
            this.gridApi.setRowData(this.state.nmntnData);
        }
        this.setState({ isDirty: false });
    }
    chkChng(n) {
        if (typeof n != 'undefined' && n != null
            && !isNaN(n.toString().replace(/,/g, '').replace('%', '')
                .replace(String.fromCharCode(40), '-').replace(String.fromCharCode(41), ''))) {
            return Number(n.toString().replace(/,/g, '').replace('%', '')
                .replace(String.fromCharCode(40), '-').replace(String.fromCharCode(41), ''));
        } else return 0;
    }
    async calculatePinnedBottomData(target, gridData, openAttribute, customFacility) {
        if (target == null) {
            target = this.state.footerItems;
        }
        if (openAttribute == null) {
            openAttribute = this.state.openAttribute;
        }
        let facility = customFacility?.value || this.props?.selectedFacOption.value;
        let lastRowData = gridData[gridData.length - 1];
        let newData = {
            Id: lastRowData?.id, ReferrenceDate: lastRowData?.referrenceDate,
            Fact: facility, Editor: lastRowData?.updatedBy
        }
        let footerItems;
        switch (facility) {
            case 'TransCanada':
                return this.calculateTranscanada(target, gridData);
                break;
            case 'Foothills':
                return this.calculateFoothills(target, gridData);
                break;
            case 'Kerrobert':
                return this.calculateKerrobert(target, gridData);
                break;
            case 'AEGS':
                return [];
                break;
            case 'NGL':
                return this.calculateNGL(target, gridData);
                break;
            case 'Propane': {
                footerItems = this.calculatePropane(
                    target, gridData, openAttribute);
                break;
            }
            case 'Butane':
                footerItems = this.calculateButane(
                    target, gridData, openAttribute);
                break;
            case 'Iso-Butane':
                footerItems = this.calculateIsoButane(
                    target, gridData, openAttribute);
                break;
            case 'Normal Butane':
                footerItems = this.calculateNormalButane(
                    target, gridData, openAttribute);
                break;
            case 'Condensate':
                footerItems = this.calculateCondensate(
                    target, gridData, openAttribute);
                break;
        }
        if (['ASSET', 'OPS'].includes(this.state.nominationRole)
            && (footerItems[0]['closingTankInvEstimates'] != lastRowData['closingTankInvEstimates'])) {
            newData.FieldRef = 'closingTankInvEstimates';
            newData.Value = footerItems[0]['closingTankInvEstimates'];
            await NominationScreenStore.saveNominationData(newData);
        }
        return footerItems;
    }
    calculateTranscanada(target, gridData) {
        let UOM = this.props?.selectedUOM?.division;
        UOM = Number(UOM);
        var rowCount = gridData.length;
        let now = new Date(momenttimezone.tz(
            moment.utc(new Date()),
            AppConstants.MT_TIME_FORMATTER
        ).format('YYYY-MM-DDT00:00:00'));

        target[0]['e1overUnder'] = '';
        target[0]['e2overUnder'] = '';
        target[0]['e5overUnder'] = '';
        target[0]['e6overUnder'] = '';
        target[0]['bypassFlowPiactuals'] = '';
        target[0]['bypassOverUnder'] = '';

        target[1]['updatedBy'] = null;
        target[1]['updatedOn'] = null;
        target[1]['e1overUnder'] = '';
        target[1]['e2overUnder'] = '';
        target[1]['e5overUnder'] = '';
        target[1]['e6overUnder'] = '';
        target[1]['bypassFlowPiactuals'] = '';
        target[1]['bypassOverUnder'] = '';

        target[2]['e1overUnder'] = '';
        target[2]['e2overUnder'] = '';
        target[2]['e5overUnder'] = '';
        target[2]['e6overUnder'] = '';
        target[2]['bypassFlowPiactuals'] = '';
        target[2]['bypassOverUnder'] = '';
        target[2]['recycleNomination'] = '';

        target[0]['borderEstimates'] = 0;
        target[0]['peepestimates'] = 0;
        target[0]['e1nomination'] = 0;
        target[0]['e2nomination'] = 0;
        target[0]['e5nomination'] = 0;
        target[0]['e6nomination'] = 0;

        target[0]['borderEstimates'] = 0;
        target[0]['peepestimates'] = 0;
        target[0]['e1nomination'] = 0;
        target[0]['e2nomination'] = 0;
        target[0]['e5nomination'] = 0;
        target[0]['e6nomination'] = 0;

        if (gridData.length > 0) {
            gridData.forEach((rowNode) => {
                if (new Date(rowNode['referrenceDate']) >= now) {
                    if (rowNode['borderEstimates'] != null) {
                        target[0]['borderEstimates'] =
                            this.chkChng(target[0]['borderEstimates']) + this.chkChng(rowNode['borderEstimates']);
                    }
                    if (rowNode['peepestimates'] != null) {
                        target[0]['peepestimates'] =
                            this.chkChng(target[0]['peepestimates']) + this.chkChng(rowNode['peepestimates']);
                    }
                    if (rowNode['e1nomination'] != null) {
                        target[0]['e1nomination'] =
                            this.chkChng(target[0]['e1nomination']) + this.chkChng(rowNode['e1nomination']);
                    }
                    if (rowNode['e2nomination'] != null) {
                        target[0]['e2nomination'] =
                            this.chkChng(target[0]['e2nomination']) + this.chkChng(rowNode['e2nomination']);
                    }
                    if (rowNode['e5nomination'] != null) {
                        target[0]['e5nomination'] =
                            this.chkChng(target[0]['e5nomination']) + this.chkChng(rowNode['e5nomination']);
                    }
                    if (rowNode['e6nomination'] != null) {
                        target[0]['e6nomination'] =
                            this.chkChng(target[0]['e6nomination']) + this.chkChng(rowNode['e6nomination']);
                    }
                } else {
                    if (rowNode['borderActuals'] != null) {
                        target[0]['borderEstimates'] =
                            this.chkChng(target[0]['borderEstimates']) + this.chkChng(rowNode['borderActuals']);
                    }
                    if (rowNode['peepactuals'] != null) {
                        target[0]['peepestimates'] =
                            this.chkChng(target[0]['peepestimates']) + this.chkChng(rowNode['peepactuals']);
                    }
                    if (rowNode['e1actuals'] != null) {
                        target[0]['e1nomination'] =
                            this.chkChng(target[0]['e1nomination']) + this.chkChng(rowNode['e1actuals']);
                    }
                    if (rowNode['e2actuals'] != null) {
                        target[0]['e2nomination'] =
                            this.chkChng(target[0]['e2nomination']) + this.chkChng(rowNode['e2actuals']);
                    }
                    if (rowNode['e5actuals'] != null) {
                        target[0]['e5nomination'] =
                            this.chkChng(target[0]['e5nomination']) + this.chkChng(rowNode['e5actuals']);
                    }
                    if (rowNode['e6actuals'] != null) {
                        target[0]['e6nomination'] =
                            this.chkChng(target[0]['e6nomination']) + this.chkChng(rowNode['e6actuals']);
                    }
                }
            });
            target[0]['borderEstimates'] = Math.round(target[0]['borderEstimates'] == null ? 0 : (this.chkChng(target[0]['borderEstimates']) / rowCount));
            target[0]['peepestimates'] = Math.round(target[0]['peepestimates'] == null ? 0 : (this.chkChng(target[0]['peepestimates']) / rowCount));
            target[0]['e1nomination'] = Math.round(target[0]['e1nomination'] == null ? 0 : (this.chkChng(target[0]['e1nomination']) / rowCount));
            target[0]['e2nomination'] = Math.round(target[0]['e2nomination'] == null ? 0 : (this.chkChng(target[0]['e2nomination']) / rowCount));
            target[0]['e5nomination'] = Math.round(target[0]['e5nomination'] == null ? 0 : (this.chkChng(target[0]['e5nomination']) / rowCount));
            target[0]['e6nomination'] = Math.round(target[0]['e6nomination'] == null ? 0 : (this.chkChng(target[0]['e6nomination']) / rowCount));
            let totalEstimates =
                (this.chkChng(target[0]['borderEstimates']) - (this.chkChng(target[0]['peepestimates'])
                    + this.chkChng(target[0]['e1nomination']) + this.chkChng(target[0]['e2nomination'])
                    + this.chkChng(target[0]['e5nomination']) + this.chkChng(target[0]['e6nomination'])));
            if (totalEstimates != 0) {
                target[0]['recycleNomination'] = totalEstimates;
            }

            let totalNominations = 0;
            if (target[1]['borderEstimates'] != null || !isNaN(target[1]['borderEstimates'])) totalNominations = this.chkChng(target[1]['borderEstimates']);
            if (target[1]['peepestimates'] != null || !isNaN(target[1]['peepestimates'])) totalNominations -= this.chkChng(target[1]['peepestimates']);
            if (target[1]['e1nomination'] != null || !isNaN(target[1]['e1nomination'])) totalNominations -= this.chkChng(target[1]['e1nomination']);
            if (target[1]['e2nomination'] != null || !isNaN(target[1]['e2nomination'])) totalNominations -= this.chkChng(target[1]['e2nomination']);
            if (target[1]['e5nomination'] != null || !isNaN(target[1]['e5nomination'])) totalNominations -= this.chkChng(target[1]['e5nomination']);
            if (target[1]['e6nomination'] != null || !isNaN(target[1]['e6nomination'])) totalNominations -= this.chkChng(target[1]['e6nomination']);
            if (totalNominations != 0) {
                target[1]['recycleNomination'] = totalNominations;
            }

            target[2]['borderEstimates'] = this.chkChng(target[0]['borderEstimates']) - ((target[1]['borderEstimates'] != null || !isNaN(target[1]['borderEstimates'])) ? this.chkChng(target[1]['borderEstimates']) : 0);
            target[2]['peepestimates'] = this.chkChng(target[0]['peepestimates']) - ((target[1]['peepestimates'] != null || !isNaN(target[1]['peepestimates'])) ? this.chkChng(target[1]['peepestimates']) : 0);
            target[2]['e1nomination'] = this.chkChng(target[0]['e1nomination']) - ((target[1]['e1nomination'] != null || !isNaN(target[1]['e1nomination'])) ? this.chkChng(target[1]['e1nomination']) : 0);
            target[2]['e2nomination'] = this.chkChng(target[0]['e2nomination']) - ((target[1]['e2nomination'] != null || !isNaN(target[1]['e2nomination'])) ? this.chkChng(target[1]['e2nomination']) : 0);
            target[2]['e5nomination'] = this.chkChng(target[0]['e5nomination']) - ((target[1]['e5nomination'] != null || !isNaN(target[1]['e5nomination'])) ? this.chkChng(target[1]['e5nomination']) : 0);
            target[2]['e6nomination'] = this.chkChng(target[0]['e6nomination']) - ((target[1]['e6nomination'] != null || !isNaN(target[1]['e6nomination'])) ? this.chkChng(target[1]['e6nomination']) : 0);

            if (UOM !== 1) {
                target.map((val, index) => {
                    target[index]['borderEstimates'] = this.chkChng(val['borderEstimates']) / UOM;
                    target[index]['peepestimates'] = this.chkChng(val['peepestimates']) / UOM;
                    target[index]['e1nomination'] = this.chkChng(val['e1nomination']) / UOM;
                    target[index]['e2nomination'] = this.chkChng(val['e2nomination']) / UOM;
                    target[index]['e5nomination'] = this.chkChng(val['e5nomination']) / UOM;
                    target[index]['e6nomination'] = this.chkChng(val['e6nomination']) / UOM;
                    target[index]['recycleNomination'] = this.chkChng(this.chkChng(val['recycleNomination']) / UOM);
                });
                target[2]['recycleNomination'] = '';
            }
        }
        return target;
    }
    calculateFoothills(target, gridData) {
        let UOM = this.props?.selectedUOM?.division;
        UOM = Number(UOM);
        target[0]['e3actuals'] = 0;
        target[0]['peepnomination'] = 0;
        target[0]['peepactuals'] = 0;
        target[0]['peepoverUnder'] = 0;
        target[0]['plainsE1e2e5nomination'] = 0;
        target[0]['perToPlainsE1e2e5actuals'] = 0;
        target[0]['plainsE1e2e5overUnder'] = 0;
        target[0]['plainsE6nomination'] = 0;
        target[0]['plainsE6actuals'] = 0;
        target[0]['plainsE6overUnder'] = 0;

        if (gridData.length > 0) {
            gridData.forEach((rowNode) => {
                target[0]['e3actuals'] = this.chkChng(target[0]['e3actuals']) + this.chkChng(rowNode.e3actuals);

                target[0]['peepnomination'] = this.chkChng(target[0]['peepnomination']) + ((this.chkChng(rowNode.e3actuals) * this.chkChng(rowNode.perToPeepNomination)) / 100);
                target[0]['peepnomination'] = Math.round(target[0]['peepnomination']);

                target[0]['peepactuals'] = this.chkChng(target[0]['peepactuals']) + this.chkChng(rowNode.peepactuals);

                target[0]['peepoverUnder'] = this.chkChng(target[0]['peepoverUnder']) + (this.chkChng(rowNode.peepactuals) - ((this.chkChng(rowNode.e3actuals) * this.chkChng(rowNode.perToPeepNomination)) / 100));
                target[0]['peepoverUnder'] = Math.round(target[0]['peepoverUnder']);

                target[0]['plainsE1e2e5nomination'] = this.chkChng(target[0]['plainsE1e2e5nomination']) + (this.chkChng(rowNode.e3actuals) * (100 - this.chkChng(rowNode.perToPeepNomination) - this.chkChng(rowNode.perToPlainsE6nomination)) / 100);
                target[0]['plainsE1e2e5nomination'] = Math.round(target[0]['plainsE1e2e5nomination']);

                target[0]['plainsE1e2e5actuals'] = this.chkChng(target[0]['e3actuals']) - this.chkChng(target[0]['peepactuals']) - this.chkChng(target[0]['plainsE6actuals']);
                target[0]['plainsE1e2e5actuals'] = Math.round(target[0]['plainsE1e2e5actuals']);

                target[0]['perToPlainsE1e2e5actuals'] = this.chkChng(target[0]['perToPlainsE1e2e5actuals']) + this.chkChng(rowNode.perToPlainsE1e2e5actuals);
                target[0]['perToPlainsE1e2e5actuals'] = this.chkChng(target[0]['perToPlainsE1e2e5actuals']);

                target[0]['plainsE1e2e5overUnder'] = this.chkChng(target[0]['plainsE1e2e5overUnder']) + ((this.chkChng(rowNode.e3actuals) - this.chkChng(rowNode.peepactuals) - this.chkChng(rowNode.plainsE6actuals)) - (this.chkChng(rowNode.e3actuals) * (100 - this.chkChng(rowNode.perToPeepNomination) - this.chkChng(rowNode.perToPlainsE6nomination)) / 100));

                target[0]['plainsE6nomination'] = this.chkChng(target[0]['plainsE6nomination']) + ((this.chkChng(rowNode.perToPlainsE6nomination) * this.chkChng(rowNode.e3actuals)) / 100);
                target[0]['plainsE6nomination'] = Math.round(target[0]['plainsE6nomination']);

                target[0]['plainsE6actuals'] = this.chkChng(target[0]['plainsE6actuals']) + this.chkChng(rowNode.plainsE6actuals);

                target[0]['plainsE6overUnder'] = this.chkChng(target[0]['plainsE6overUnder']) + (this.chkChng(rowNode.plainsE6actuals) - ((this.chkChng(rowNode.perToPlainsE6nomination) * this.chkChng(rowNode.e3actuals)) / 100));
                target[0]['plainsE6overUnder'] = Math.round(target[0]['plainsE6overUnder']);
            });

            if (UOM !== 1) {
                target[0]['e3actuals'] = this.chkChng(target[0]['e3actuals']) / UOM;
                target[0]['peepnomination'] = this.chkChng(target[0]['peepnomination']) / UOM;
                target[0]['peepactuals'] = this.chkChng(target[0]['peepactuals']) / UOM;
                target[0]['peepoverUnder'] = this.chkChng(target[0]['peepoverUnder']) / UOM;
                target[0]['plainsE1e2e5nomination'] = this.chkChng(target[0]['plainsE1e2e5nomination']) / UOM;
                target[0]['plainsE1e2e5actuals'] = this.chkChng(target[0]['plainsE1e2e5actuals']) / UOM;
                target[0]['perToPlainsE1e2e5actuals'] = this.chkChng(target[0]['perToPlainsE1e2e5actuals']) / UOM;
                target[0]['plainsE1e2e5overUnder'] = this.chkChng(target[0]['plainsE1e2e5overUnder']) / UOM;
                target[0]['plainsE6nomination'] = this.chkChng(target[0]['plainsE6nomination']) / UOM;
                target[0]['plainsE6actuals'] = this.chkChng(target[0]['plainsE6actuals']) / UOM;
                target[0]['plainsE6overUnder'] = this.chkChng(target[0]['plainsE6overUnder']) / UOM;
            }
        }
        return target;
    }
    calculateKerrobert(target, gridData) {
        var rowCount = gridData.length;
        let now = new Date(momenttimezone.tz(
            moment.utc(new Date()),
            AppConstants.MT_TIME_FORMATTER
        ).format('YYYY-MM-DDT00:00:00'));

        target[0]['ngltoKerrobertOverUnder'] = '';
        target[1]['ngltoKerrobertOverUnder'] = '';
        target[2]['ngltoKerrobertOverUnder'] = '';
        target[2]['updatedBy'] = null;
        target[2]['updatedOn'] = null;
        target[3]['ngltoKerrobertOverUnder'] = '';
        target[0]['pipelineRateEstimates'] = '';

        target[0]['ngltoKerrobertEstimates'] = 0;
        var pipelineRate = 0;

        if (gridData.length > 0) {
            gridData.forEach((rowNode) => {
                if (new Date(rowNode['referrenceDate']) >= now) {
                    target[0]['ngltoKerrobertEstimates'] = this.chkChng(target[0]['ngltoKerrobertEstimates']) + this.chkChng(rowNode.ngltoKerrobertEstimates);
                    pipelineRate = pipelineRate + (this.chkChng(rowNode.ngltoKerrobertEstimates) / 24);
                } else {
                    target[0]['ngltoKerrobertEstimates'] = this.chkChng(target[0]['ngltoKerrobertEstimates']) + this.chkChng(rowNode.ngltoKerrobertActuals);
                    pipelineRate = pipelineRate + (this.chkChng(rowNode.ngltoKerrobertActuals) / 24)
                }
            });

            target[1]['ngltoKerrobertEstimates'] = '';
            target[1]['pipelineRateEstimates'] = Math.round(pipelineRate / rowCount);
            target[1]['pipelineRateEstimates'] = this.chkChng(target[1]['pipelineRateEstimates']);

            target[2]['pipelineRateEstimates'] = ((this.chkChng(target[2]['ngltoKerrobertEstimates']) / rowCount) / 24);
            target[2]['pipelineRateEstimates'] = Math.round(this.chkChng(target[2]['pipelineRateEstimates']));

            target[3]['ngltoKerrobertEstimates'] = this.chkChng(target[0]['ngltoKerrobertEstimates']) - this.chkChng(target[2]['ngltoKerrobertEstimates']);
            target[3]['ngltoKerrobertEstimates'] = this.chkChng(target[3]['ngltoKerrobertEstimates']);
            target[3]['pipelineRateEstimates'] = this.chkChng(target[1]['pipelineRateEstimates']) - this.chkChng(target[2]['pipelineRateEstimates']);
            target[3]['pipelineRateEstimates'] = Math.round(this.chkChng(target[3]['pipelineRateEstimates']));
        }
        return target;
    }
    calculateNGL(target, gridData) {
        var rowCount = gridData.length;
        let now = new Date(momenttimezone.tz(
            moment.utc(new Date()),
            AppConstants.MT_TIME_FORMATTER
        ).format('YYYY-MM-DDT00:00:00'));

        target[0]['nglyieldBblsMmcf'] = '';
        target[1]['nglyieldBblsMmcf'] = '';
        target[2]['nglyieldBblsMmcf'] = '';
        target[3]['nglyieldBblsMmcf'] = '';

        target[0]['nglyieldBblsActuals'] = '';
        target[1]['nglyieldBblsActuals'] = '';
        target[2]['nglyieldBblsActuals'] = '';
        target[3]['nglyieldBblsActuals'] = '';

        target[0]['trsfInfromE1e5toE6overUnder'] = '';
        target[1]['trsfInfromE1e5toE6overUnder'] = '';
        target[2]['trsfInfromE1e5toE6overUnder'] = '';
        target[3]['trsfInfromE1e5toE6overUnder'] = '';

        target[0]['trsfInfromE1toE6overUnder'] = '';
        target[1]['trsfInfromE1toE6overUnder'] = '';
        target[2]['trsfInfromE1toE6overUnder'] = '';
        target[3]['trsfInfromE1toE6overUnder'] = '';

        target[0]['ngltruckOffloadOverUnder'] = '';
        target[1]['ngltruckOffloadOverUnder'] = '';
        target[2]['ngltruckOffloadOverUnder'] = '';
        target[3]['ngltruckOffloadOverUnder'] = '';

        target[0]['nglrailOffloadOverUnder'] = '';
        target[1]['nglrailOffloadOverUnder'] = '';
        target[2]['nglrailOffloadOverUnder'] = '';
        target[3]['nglrailOffloadOverUnder'] = '';

        target[0]['ngltruckLoadingOverUnder'] = '';
        target[1]['ngltruckLoadingOverUnder'] = '';
        target[2]['ngltruckLoadingOverUnder'] = '';
        target[3]['ngltruckLoadingOverUnder'] = '';

        target[0]['nglrailLoadingOverUnder'] = '';
        target[1]['nglrailLoadingOverUnder'] = '';
        target[2]['nglrailLoadingOverUnder'] = '';
        target[3]['nglrailLoadingOverUnder'] = '';

        target[0]['totalC3productionOverUnder'] = '';
        target[1]['totalC3productionOverUnder'] = '';
        target[2]['totalC3productionOverUnder'] = '';
        target[3]['totalC3productionOverUnder'] = '';

        target[2]['updatedBy'] = '';
        target[2]['updatedOn'] = '';

        target[1]['e6straddleFrontEndEstimates'] = 0;
        target[1]['trsfInfromE1e5toE6nomination'] = 0;
        target[1]['trsfInfromE1toE6nomination'] = 0;
        target[1]['ngltruckOffloadNomination'] = 0;
        target[1]['nglrailOffloadNomination'] = 0;
        target[1]['ngltruckLoadingNomination'] = 0;
        target[1]['nglrailLoadingNomination'] = 0;
        target[1]['totalC3productionNomination'] = 0;

        if (gridData.length > 0) {
            gridData.forEach((rowNode) => {
                if (new Date(rowNode['referrenceDate']) >= now) {
                    target[1]['e6straddleFrontEndEstimates'] = this.chkChng(target[1]['e6straddleFrontEndEstimates'])
                        + Number(parseFloat((this.chkChng(rowNode.e6nomination) / 28.327) * (this.chkChng(rowNode.nglyieldBblsMmcf) / 6.29287)).toFixed(2));
                    target[1]['trsfInfromE1e5toE6nomination'] = this.chkChng(target[1]['trsfInfromE1e5toE6nomination']) + this.chkChng(rowNode.trsfInfromE1e5toE6nomination);
                    target[1]['trsfInfromE1toE6nomination'] = this.chkChng(target[1]['trsfInfromE1toE6nomination']) + this.chkChng(rowNode.trsfInfromE1toE6nomination);
                    target[1]['ngltruckOffloadNomination'] = this.chkChng(target[1]['ngltruckOffloadNomination']) + this.chkChng(rowNode.ngltruckOffloadNomination);
                    target[1]['nglrailOffloadNomination'] = this.chkChng(target[1]['nglrailOffloadNomination']) + this.chkChng(rowNode.nglrailOffloadNomination);
                    target[1]['ngltruckLoadingNomination'] = this.chkChng(target[1]['ngltruckLoadingNomination']) + this.chkChng(rowNode.ngltruckLoadingNomination);
                    target[1]['nglrailLoadingNomination'] = this.chkChng(target[1]['nglrailLoadingNomination']) + this.chkChng(rowNode.nglrailLoadingNomination);
                    target[1]['totalC3productionNomination'] = this.chkChng(target[1]['totalC3productionNomination'])
                        + Number(parseFloat(((this.chkChng(rowNode.e6nomination) / 28.327) * (this.chkChng(rowNode.nglyieldBblsMmcf) / 6.29287))
                            + this.chkChng(rowNode.trsfInfromE1e5toE6nomination) + this.chkChng(rowNode.trsfInfromE1toE6nomination)
                            + this.chkChng(rowNode.ngltruckOffloadNomination) + this.chkChng(rowNode.nglrailOffloadNomination)
                            + this.chkChng(rowNode.ngltruckLoadingNomination) + this.chkChng(rowNode.nglrailLoadingNomination)).toFixed(2));
                } else {
                    target[1]['e6straddleFrontEndEstimates'] = this.chkChng(target[1]['e6straddleFrontEndEstimates'])
                        + (this.chkChng(rowNode.totalC3productionActuals) - this.chkChng(rowNode.trsfInfromE1e5toE6actuals)
                            - this.chkChng(rowNode.trsfInfromE1toE6actuals) - this.chkChng(rowNode.ngltruckOffloadActuals)
                            - this.chkChng(rowNode.nglrailOffloadActuals) - this.chkChng(rowNode.ngltruckLoadingActuals)
                            - this.chkChng(rowNode.nglrailLoadingActuals));
                    target[1]['trsfInfromE1e5toE6nomination'] = this.chkChng(target[1]['trsfInfromE1e5toE6nomination']) + this.chkChng(rowNode.trsfInfromE1e5toE6actuals);
                    target[1]['trsfInfromE1toE6nomination'] = this.chkChng(target[1]['trsfInfromE1toE6nomination']) + this.chkChng(rowNode.trsfInfromE1toE6actuals);
                    target[1]['ngltruckOffloadNomination'] = this.chkChng(target[1]['ngltruckOffloadNomination']) + this.chkChng(rowNode.ngltruckOffloadActuals);
                    target[1]['nglrailOffloadNomination'] = this.chkChng(target[1]['nglrailOffloadNomination']) + this.chkChng(rowNode.nglrailOffloadActuals);
                    target[1]['ngltruckLoadingNomination'] = this.chkChng(target[1]['ngltruckLoadingNomination']) + this.chkChng(rowNode.ngltruckLoadingActuals);
                    target[1]['nglrailLoadingNomination'] = this.chkChng(target[1]['nglrailLoadingNomination']) + this.chkChng(rowNode.nglrailLoadingActuals);
                    target[1]['totalC3productionNomination'] = this.chkChng(target[1]['totalC3productionNomination']) + this.chkChng(rowNode.totalC3productionActuals);
                }
            });

            target[0]['e6straddleFrontEndEstimates'] = parseFloat(this.chkChng(target[1]['e6straddleFrontEndEstimates']) / rowCount).toFixed(2);
            target[0]['trsfInfromE1e5toE6nomination'] = parseFloat(this.chkChng(target[1]['trsfInfromE1e5toE6nomination']) / rowCount).toFixed(2);
            target[0]['trsfInfromE1toE6nomination'] = parseFloat(this.chkChng(target[1]['trsfInfromE1toE6nomination']) / rowCount).toFixed(2);
            target[0]['ngltruckOffloadNomination'] = parseFloat(this.chkChng(target[1]['ngltruckOffloadNomination']) / rowCount).toFixed(2);
            target[0]['nglrailOffloadNomination'] = parseFloat(this.chkChng(target[1]['nglrailOffloadNomination']) / rowCount).toFixed(2);
            target[0]['ngltruckLoadingNomination'] = parseFloat(this.chkChng(target[1]['ngltruckLoadingNomination']) / rowCount).toFixed(2);
            target[0]['nglrailLoadingNomination'] = parseFloat(this.chkChng(target[1]['nglrailLoadingNomination']) / rowCount).toFixed(2);
            target[0]['totalC3productionNomination'] = parseFloat(this.chkChng(target[1]['totalC3productionNomination']) / rowCount).toFixed(2);

            target[3]['e6straddleFrontEndEstimates'] = this.chkChng(target[1]['e6straddleFrontEndEstimates']) - this.chkChng(target[2]['e6straddleFrontEndEstimates']);
            target[3]['trsfInfromE1e5toE6nomination'] = this.chkChng(target[1]['trsfInfromE1e5toE6nomination']) - this.chkChng(target[2]['trsfInfromE1e5toE6nomination']);
            target[3]['trsfInfromE1toE6nomination'] = this.chkChng(target[1]['trsfInfromE1toE6nomination']) - this.chkChng(target[2]['trsfInfromE1toE6nomination']);
            target[3]['ngltruckOffloadNomination'] = this.chkChng(target[1]['ngltruckOffloadNomination']) - this.chkChng(target[2]['ngltruckOffloadNomination']);
            target[3]['nglrailOffloadNomination'] = this.chkChng(target[1]['nglrailOffloadNomination']) - this.chkChng(target[2]['nglrailOffloadNomination']);
            target[3]['ngltruckLoadingNomination'] = this.chkChng(target[1]['ngltruckLoadingNomination']) - this.chkChng(target[2]['ngltruckLoadingNomination']);
            target[3]['nglrailLoadingNomination'] = this.chkChng(target[1]['nglrailLoadingNomination']) - this.chkChng(target[2]['nglrailLoadingNomination']);
            target[3]['totalC3productionNomination'] = this.chkChng(target[1]['totalC3productionNomination']) - this.chkChng(target[2]['totalC3productionNomination']);
        }
        return target;
    }
    calculatePropane(target, gridData, openAttribute) {
        var rowCount = gridData.length;
        let now = new Date(momenttimezone.tz(
            moment.utc(new Date()),
            AppConstants.MT_TIME_FORMATTER
        ).format('YYYY-MM-DDT00:00:00'));

        target[1]['openingInvEstimates'] = '';
        target[2]['openingInvEstimates'] = '';

        target[0]['openingInvActuals'] = '';
        target[1]['openingInvActuals'] = '';
        target[2]['openingInvActuals'] = '';

        target[1]['closingRailcarInvEstimates'] = '';
        target[2]['closingRailcarInvEstimates'] = '';

        target[1]['closingTankInvEstimates'] = '';
        target[2]['closingTankInvEstimates'] = '';

        target[0]['maxStorageM3'] = '';
        target[1]['maxStorageM3'] = '';
        target[2]['maxStorageM3'] = '';

        target[0]['percentofSafeLevelEstimates'] = null;
        target[1]['percentofSafeLevelEstimates'] = null;
        target[2]['percentofSafeLevelEstimates'] = null;

        target[0]['percentofSafeLevelActuals'] = null;
        target[1]['percentofSafeLevelActuals'] = null;
        target[2]['percentofSafeLevelActuals'] = null;

        target[1]['updatedBy'] = '';
        target[1]['updatedOn'] = '';

        target[0]['openingInvEstimates'] = openAttribute;
        target[0]['productionEstimates'] = 0;
        target[0]['offspecRerunEstimates'] = 0;
        target[0]['truckNomination'] = 0;
        target[0]['railNomination'] = 0;
        target[0]['pptcnomination'] = 0;
        target[0]['trsfOutto15Nomination'] = 0;
        target[0]['reinjectionEstimates'] = 0;
        target[0]['gainLossEstimates'] = 0;

        if (gridData.length > 0) {
            gridData.forEach((rowNode, index) => {
                if (new Date(rowNode['referrenceDate']) >= now) {
                    target[0]['productionEstimates'] = this.chkChng(target[0]['productionEstimates'])
                        + Number(parseFloat((((this.chkChng(rowNode.e6nomination) / 28.327) * (this.chkChng(rowNode.nglyieldBblsMmcf) / 6.29287))
                            + this.chkChng(rowNode.trsfInfromE1e5toE6nomination) + this.chkChng(rowNode.trsfInfromE1toE6nomination)
                            + this.chkChng(rowNode.ngltruckOffloadNomination) + this.chkChng(rowNode.nglrailOffloadNomination)
                            + this.chkChng(rowNode.ngltruckLoadingNomination) + this.chkChng(rowNode.nglrailLoadingNomination))
                            * this.chkChng(rowNode.compositionPercent) / 100).toFixed(2));
                    target[0]['offspecRerunEstimates'] = this.chkChng(target[0]['offspecRerunEstimates']) + this.chkChng(rowNode.offspecRerunEstimates);
                    target[0]['truckNomination'] = this.chkChng(target[0]['truckNomination']) + this.chkChng(rowNode.truckNomination);
                    target[0]['railNomination'] = this.chkChng(target[0]['railNomination']) + this.chkChng(rowNode.railNomination);
                    target[0]['pptcnomination'] = this.chkChng(target[0]['pptcnomination']) + this.chkChng(rowNode.pptcnomination);
                    target[0]['trsfOutto15Nomination'] = this.chkChng(target[0]['trsfOutto15Nomination']) + this.chkChng(rowNode.trsfOutto15Nomination);
                    target[0]['reinjectionEstimates'] = this.chkChng(target[0]['reinjectionEstimates']) + this.chkChng(rowNode.reinjectionEstimates);
                    target[0]['gainLossEstimates'] = this.chkChng(target[0]['gainLossEstimates']) + this.chkChng(rowNode.gainLossEstimates);
                } else {
                    target[0]['productionEstimates'] = this.chkChng(target[0]['productionEstimates']) + this.chkChng(rowNode.productionActuals);
                    target[0]['offspecRerunEstimates'] = this.chkChng(target[0]['offspecRerunEstimates']) + this.chkChng(rowNode.offspecRerunActuals);
                    target[0]['truckNomination'] = this.chkChng(target[0]['truckNomination']) + this.chkChng(rowNode.truckActuals);
                    target[0]['railNomination'] = this.chkChng(target[0]['railNomination']) + this.chkChng(rowNode.railActuals);
                    target[0]['pptcnomination'] = this.chkChng(target[0]['pptcnomination']) + this.chkChng(rowNode.pptcactuals);
                    target[0]['trsfOutto15Nomination'] = this.chkChng(target[0]['trsfOutto15Nomination']) + this.chkChng(rowNode.trsfOutto15Actuals);
                    target[0]['reinjectionEstimates'] = this.chkChng(target[0]['reinjectionEstimates']) + this.chkChng(rowNode.reinjectionActuals);
                    target[0]['gainLossEstimates'] = this.chkChng(target[0]['gainLossEstimates']) + this.chkChng(rowNode.gainLossActuals);
                }
                if (index == (rowCount - 1)) {
                    if (new Date(rowNode['referrenceDate']) > new Date())
                        target[0]['closingRailcarInvEstimates'] = this.chkChng(rowNode.closingRailcarInvEstimates);
                    else
                        target[0]['closingRailcarInvEstimates'] = this.chkChng(rowNode.closingRailcarInvActuals);
                }
            });

            target[0]['closingTankInvEstimates'] = (target[0]['openingInvEstimates']
                + this.chkChng(target[0]['productionEstimates']) + this.chkChng(target[0]['offspecRerunEstimates'])
                + this.chkChng(target[0]['truckNomination']) + this.chkChng(target[0]['railNomination'])
                + this.chkChng(target[0]['pptcnomination']) + this.chkChng(target[0]['trsfOutto15Nomination'])
                + this.chkChng(target[0]['reinjectionEstimates']) + this.chkChng(target[0]['gainLossEstimates'])
            ) - target[0]['closingRailcarInvEstimates'];

            target[2]['productionEstimates'] = this.chkChng(target[0]['productionEstimates']) - this.chkChng(target[1]['productionEstimates']);
            target[2]['offspecRerunEstimates'] = this.chkChng(target[0]['offspecRerunEstimates']) - this.chkChng(target[1]['offspecRerunEstimates']);
            target[2]['truckNomination'] = this.chkChng(target[0]['truckNomination']) - this.chkChng(target[1]['truckNomination']);
            target[2]['railNomination'] = this.chkChng(target[0]['railNomination']) - this.chkChng(target[1]['railNomination']);
            target[2]['pptcnomination'] = this.chkChng(target[0]['pptcnomination']) - this.chkChng(target[1]['pptcnomination']);
            target[2]['trsfOutto15Nomination'] = this.chkChng(target[0]['trsfOutto15Nomination']) - this.chkChng(target[1]['trsfOutto15Nomination']);
            target[2]['reinjectionEstimates'] = this.chkChng(target[0]['reinjectionEstimates']) - this.chkChng(target[1]['reinjectionEstimates']);
            target[2]['gainLossEstimates'] = this.chkChng(target[0]['gainLossEstimates']) - this.chkChng(target[1]['gainLossEstimates']);
        }
        return target;
    }
    calculateButane(target, gridData, openAttribute) {
        var rowCount = gridData.length;
        let now = new Date(momenttimezone.tz(
            moment.utc(new Date()),
            AppConstants.MT_TIME_FORMATTER
        ).format('YYYY-MM-DDT00:00:00'));

        target[1]['openingInvEstimates'] = '';
        target[2]['openingInvEstimates'] = '';

        target[0]['openingInvActuals'] = '';
        target[1]['openingInvActuals'] = '';
        target[2]['openingInvActuals'] = '';

        target[0]['offspecRerunActuals'] = '';
        target[1]['offspecRerunActuals'] = '';
        target[2]['offspecRerunActuals'] = '';

        target[0]['trsfOutto15Actuals'] = '';
        target[1]['trsfOutto15Actuals'] = '';
        target[2]['trsfOutto15Actuals'] = '';

        target[0]['reinjectionActuals'] = '';
        target[1]['reinjectionActuals'] = '';
        target[2]['reinjectionActuals'] = '';

        target[0]['gainLossActuals'] = '';
        target[1]['gainLossActuals'] = '';
        target[2]['gainLossActuals'] = '';

        target[1]['closingRailcarInvEstimates'] = '';
        target[2]['closingRailcarInvEstimates'] = '';

        target[1]['closingTankInvEstimates'] = '';
        target[2]['closingTankInvEstimates'] = '';

        target[0]['maxStorageM3'] = '';
        target[1]['maxStorageM3'] = '';
        target[2]['maxStorageM3'] = '';

        target[0]['percentofSafeLevelEstimates'] = null;
        target[1]['percentofSafeLevelEstimates'] = null;
        target[2]['percentofSafeLevelEstimates'] = null;

        target[0]['percentofSafeLevelActuals'] = null;
        target[1]['percentofSafeLevelActuals'] = null;
        target[2]['percentofSafeLevelActuals'] = null;

        target[1]['updatedBy'] = '';
        target[1]['updatedOn'] = '';

        target[0]['openingInvEstimates'] = openAttribute;
        target[0]['productionEstimates'] = 0;
        target[0]['offspecRerunEstimates'] = 0;
        target[0]['truckNomination'] = 0;
        target[0]['railNomination'] = 0;
        target[0]['pptcnomination'] = 0;
        target[0]['trsfOutto15Nomination'] = 0;
        target[0]['reinjectionEstimates'] = 0;
        target[0]['gainLossEstimates'] = 0;

        if (gridData.length > 0) {
            gridData.forEach((rowNode, index) => {
                if (new Date(rowNode['referrenceDate']) >= now) {
                    target[0]['productionEstimates'] = this.chkChng(target[0]['productionEstimates']) +
                        Number(parseFloat((((this.chkChng(rowNode.e6nomination) / 28.327) * (this.chkChng(rowNode.nglyieldBblsMmcf) / 6.29287))
                            + this.chkChng(rowNode.trsfInfromE1e5toE6nomination) + this.chkChng(rowNode.trsfInfromE1toE6nomination)
                            + this.chkChng(rowNode.ngltruckOffloadNomination) + this.chkChng(rowNode.nglrailOffloadNomination)
                            + this.chkChng(rowNode.ngltruckLoadingNomination) + this.chkChng(rowNode.nglrailLoadingNomination))
                            * this.chkChng(rowNode.compositionPercent) / 100).toFixed(2));
                    target[0]['offspecRerunEstimates'] = this.chkChng(target[0]['offspecRerunEstimates']) + this.chkChng(rowNode.offspecRerunEstimates);
                    target[0]['truckNomination'] = this.chkChng(target[0]['truckNomination']) + this.chkChng(rowNode.truckNomination);
                    target[0]['railNomination'] = this.chkChng(target[0]['railNomination']) + this.chkChng(rowNode.railNomination);
                    target[0]['pptcnomination'] = this.chkChng(target[0]['pptcnomination']) + this.chkChng(rowNode.pptcnomination);
                    target[0]['trsfOutto15Nomination'] = this.chkChng(target[0]['trsfOutto15Nomination']) + this.chkChng(rowNode.trsfOutto15Nomination);
                    target[0]['reinjectionEstimates'] = this.chkChng(target[0]['reinjectionEstimates']) + this.chkChng(rowNode.reinjectionEstimates);
                    target[0]['gainLossEstimates'] = this.chkChng(target[0]['gainLossEstimates']) + this.chkChng(rowNode.gainLossEstimates);
                } else {
                    target[0]['productionEstimates'] = this.chkChng(target[0]['productionEstimates']) + this.chkChng(rowNode.productionActuals);
                    target[0]['offspecRerunEstimates'] = this.chkChng(target[0]['offspecRerunEstimates']) + this.chkChng(rowNode.offspecRerunActuals);
                    target[0]['truckNomination'] = this.chkChng(target[0]['truckNomination']) + this.chkChng(rowNode.truckActuals);
                    target[0]['railNomination'] = this.chkChng(target[0]['railNomination']) + this.chkChng(rowNode.railActuals);
                    target[0]['pptcnomination'] = this.chkChng(target[0]['pptcnomination']) + this.chkChng(rowNode.pptcactuals);
                    target[0]['trsfOutto15Nomination'] = this.chkChng(target[0]['trsfOutto15Nomination']) + this.chkChng(rowNode.trsfOutto15Actuals);
                    target[0]['reinjectionEstimates'] = this.chkChng(target[0]['reinjectionEstimates']) + this.chkChng(rowNode.reinjectionActuals);
                    target[0]['gainLossEstimates'] = this.chkChng(target[0]['gainLossEstimates']) + this.chkChng(rowNode.gainLossActuals);
                }
                if (index == (rowCount - 1)) {
                    if (new Date(rowNode['referrenceDate']) > new Date())
                        target[0]['closingRailcarInvEstimates'] = this.chkChng(rowNode.closingRailcarInvEstimates);
                    else
                        target[0]['closingRailcarInvEstimates'] = this.chkChng(rowNode.closingRailcarInvActuals);
                }
            });

            target[0]['closingTankInvEstimates'] = (this.chkChng(target[0]['openingInvEstimates'])
                + this.chkChng(target[0]['productionEstimates']) + this.chkChng(target[0]['offspecRerunEstimates'])
                + this.chkChng(target[0]['truckNomination']) + this.chkChng(target[0]['railNomination'])
                + this.chkChng(target[0]['pptcnomination']) + this.chkChng(target[0]['trsfOutto15Nomination'])
                + this.chkChng(target[0]['reinjectionEstimates']) + this.chkChng(target[0]['gainLossEstimates'])
            ) - (this.chkChng(target[0]['closingRailcarInvEstimates']))

            target[2]['productionEstimates'] = this.chkChng(target[0]['productionEstimates']) - this.chkChng(target[1]['productionEstimates']);
            target[2]['offspecRerunEstimates'] = this.chkChng(target[0]['offspecRerunEstimates']) - this.chkChng(target[1]['offspecRerunEstimates']);
            target[2]['truckNomination'] = this.chkChng(target[0]['truckNomination']) - this.chkChng(target[1]['truckNomination']);
            target[2]['railNomination'] = this.chkChng(target[0]['railNomination']) - this.chkChng(target[1]['railNomination']);
            target[2]['pptcnomination'] = this.chkChng(target[0]['pptcnomination']) - this.chkChng(target[1]['pptcnomination']);
            target[2]['trsfOutto15Nomination'] = this.chkChng(target[0]['trsfOutto15Nomination']) - this.chkChng(target[1]['trsfOutto15Nomination']);
            target[2]['reinjectionEstimates'] = this.chkChng(target[0]['reinjectionEstimates']) - this.chkChng(target[1]['reinjectionEstimates']);
            target[2]['gainLossEstimates'] = this.chkChng(target[0]['gainLossEstimates']) - this.chkChng(target[1]['gainLossEstimates']);
        }
        return target;
    }
    calculateIsoButane(target, gridData, openAttribute) {
        var rowCount = gridData.length;
        let now = new Date(momenttimezone.tz(
            moment.utc(new Date()),
            AppConstants.MT_TIME_FORMATTER
        ).format('YYYY-MM-DDT00:00:00'));

        target[1]['openingInvEstimates'] = '';
        target[2]['openingInvEstimates'] = '';

        target[0]['openingInvActuals'] = '';
        target[1]['openingInvActuals'] = '';
        target[2]['openingInvActuals'] = '';

        target[1]['closingRailcarInvEstimates'] = '';
        target[2]['closingRailcarInvEstimates'] = '';

        target[1]['closingTankInvEstimates'] = '';
        target[2]['closingTankInvEstimates'] = '';

        target[0]['maxStorageM3'] = '';
        target[1]['maxStorageM3'] = '';
        target[2]['maxStorageM3'] = '';

        target[0]['percentofSafeLevelEstimates'] = null;
        target[1]['percentofSafeLevelEstimates'] = null;
        target[2]['percentofSafeLevelEstimates'] = null;

        target[0]['percentofSafeLevelActuals'] = null;
        target[1]['percentofSafeLevelActuals'] = null;
        target[2]['percentofSafeLevelActuals'] = null;

        target[1]['updatedBy'] = '';
        target[1]['updatedOn'] = '';

        target[0]['openingInvEstimates'] = openAttribute;
        target[0]['productionEstimates'] = 0;
        target[0]['offspecRerunEstimates'] = 0;
        target[0]['railNomination'] = 0;
        target[0]['pptcnomination'] = 0;
        target[0]['trsfOutto15Nomination'] = 0;
        target[0]['reinjectionEstimates'] = 0;
        target[0]['gainLossEstimates'] = 0;

        if (gridData.length > 0) {
            gridData.forEach((rowNode, index) => {
                if (new Date(rowNode['referrenceDate']) >= now) {
                    target[0]['productionEstimates'] = this.chkChng(target[0]['productionEstimates'])
                        + Number(parseFloat((((this.chkChng(rowNode.e6nomination) / 28.327)
                            * (this.chkChng(rowNode.nglyieldBblsMmcf) / 6.29287)) + this.chkChng(rowNode.trsfInfromE1e5toE6nomination)
                            + this.chkChng(rowNode.trsfInfromE1toE6nomination) + this.chkChng(rowNode.ngltruckOffloadNomination)
                            + this.chkChng(rowNode.nglrailOffloadNomination) + this.chkChng(rowNode.ngltruckLoadingNomination)
                            + this.chkChng(rowNode.nglrailLoadingNomination)) * this.chkChng(rowNode.compositionPercent) / 100).toFixed(2));
                    target[0]['offspecRerunEstimates'] = this.chkChng(target[0]['offspecRerunEstimates']) + this.chkChng(rowNode.offspecRerunEstimates);
                    target[0]['railNomination'] = this.chkChng(target[0]['railNomination']) + this.chkChng(rowNode.railNomination);
                    target[0]['pptcnomination'] = this.chkChng(target[0]['pptcnomination']) + this.chkChng(rowNode.pptcnomination);
                    target[0]['trsfOutto15Nomination'] = this.chkChng(target[0]['trsfOutto15Nomination']) + this.chkChng(rowNode.trsfOutto15Nomination);
                    target[0]['reinjectionEstimates'] = this.chkChng(target[0]['reinjectionEstimates']) + this.chkChng(rowNode.reinjectionEstimates);
                    target[0]['gainLossEstimates'] = this.chkChng(target[0]['gainLossEstimates']) + this.chkChng(rowNode.gainLossEstimates);
                } else {
                    target[0]['productionEstimates'] = this.chkChng(target[0]['productionEstimates']) + this.chkChng(rowNode.productionActuals);
                    target[0]['offspecRerunEstimates'] = this.chkChng(target[0]['offspecRerunEstimates']) + this.chkChng(rowNode.offspecRerunActuals);
                    target[0]['railNomination'] = this.chkChng(target[0]['railNomination']) + this.chkChng(rowNode.railActuals);
                    target[0]['pptcnomination'] = this.chkChng(target[0]['pptcnomination']) + this.chkChng(rowNode.pptcactuals);
                    target[0]['trsfOutto15Nomination'] = this.chkChng(target[0]['trsfOutto15Nomination']) + this.chkChng(rowNode.trsfOutto15Actuals);
                    target[0]['reinjectionEstimates'] = this.chkChng(target[0]['reinjectionEstimates']) + this.chkChng(rowNode.reinjectionActuals);
                    target[0]['gainLossEstimates'] = this.chkChng(target[0]['gainLossEstimates']) + this.chkChng(rowNode.gainLossActuals);
                }
                if (index == (rowCount - 1)) {
                    if (new Date(rowNode['referrenceDate']) > new Date())
                        target[0]['closingRailcarInvEstimates'] = this.chkChng(rowNode.closingRailcarInvEstimates);
                    else
                        target[0]['closingRailcarInvEstimates'] = this.chkChng(rowNode.closingRailcarInvActuals);
                }
            });

            target[0]['closingTankInvEstimates'] = (this.chkChng(target[0]['openingInvEstimates'])
                + this.chkChng(target[0]['productionEstimates']) + this.chkChng(target[0]['offspecRerunEstimates'])
                + this.chkChng(target[0]['railNomination']) + this.chkChng(target[0]['pptcnomination'])
                + this.chkChng(target[0]['trsfOutto15Nomination']) + this.chkChng(target[0]['reinjectionEstimates'])
                + this.chkChng(target[0]['gainLossEstimates'])) - target[0]['closingRailcarInvEstimates'];

            target[2]['productionEstimates'] = this.chkChng(target[0]['productionEstimates']) - this.chkChng(target[1]['productionEstimates']);
            target[2]['offspecRerunEstimates'] = this.chkChng(target[0]['offspecRerunEstimates']) - this.chkChng(target[1]['offspecRerunEstimates']);
            target[2]['railNomination'] = this.chkChng(target[0]['railNomination']) - this.chkChng(target[1]['railNomination']);
            target[2]['pptcnomination'] = this.chkChng(target[0]['pptcnomination']) - this.chkChng(target[1]['pptcnomination']);
            target[2]['trsfOutto15Nomination'] = this.chkChng(target[0]['trsfOutto15Nomination']) - this.chkChng(target[1]['trsfOutto15Nomination']);
            target[2]['reinjectionEstimates'] = this.chkChng(target[0]['reinjectionEstimates']) - this.chkChng(target[1]['reinjectionEstimates']);
            target[2]['gainLossEstimates'] = this.chkChng(target[0]['gainLossEstimates']) - this.chkChng(target[1]['gainLossEstimates']);
        }
        return target;
    }
    calculateNormalButane(target, gridData, openAttribute) {
        var rowCount = gridData.length;
        let now = new Date(momenttimezone.tz(
            moment.utc(new Date()),
            AppConstants.MT_TIME_FORMATTER
        ).format('YYYY-MM-DDT00:00:00'));

        target[1]['openingInvEstimates'] = '';
        target[2]['openingInvEstimates'] = '';

        target[0]['openingInvActuals'] = '';
        target[1]['openingInvActuals'] = '';
        target[2]['openingInvActuals'] = '';

        target[0]['offspecRerunActuals'] = '';
        target[1]['offspecRerunActuals'] = '';
        target[2]['offspecRerunActuals'] = '';

        target[0]['trsfOutto15Actuals'] = '';
        target[1]['trsfOutto15Actuals'] = '';
        target[2]['trsfOutto15Actuals'] = '';

        target[0]['reinjectionActuals'] = '';
        target[1]['reinjectionActuals'] = '';
        target[2]['reinjectionActuals'] = '';

        target[0]['gainLossActuals'] = '';
        target[1]['gainLossActuals'] = '';
        target[2]['gainLossActuals'] = '';

        target[1]['closingRailcarInvEstimates'] = '';
        target[2]['closingRailcarInvEstimates'] = '';

        target[1]['closingTankInvEstimates'] = '';
        target[2]['closingTankInvEstimates'] = '';

        target[0]['maxStorageM3'] = '';
        target[1]['maxStorageM3'] = '';
        target[2]['maxStorageM3'] = '';

        target[0]['percentofSafeLevelEstimates'] = null;
        target[1]['percentofSafeLevelEstimates'] = null;
        target[2]['percentofSafeLevelEstimates'] = null;

        target[0]['percentofSafeLevelActuals'] = null;
        target[1]['percentofSafeLevelActuals'] = null;
        target[2]['percentofSafeLevelActuals'] = null;

        target[1]['updatedBy'] = '';
        target[1]['updatedOn'] = '';

        target[0]['openingInvEstimates'] = openAttribute;
        target[0]['productionEstimates'] = 0;
        target[0]['offspecRerunEstimates'] = 0;
        target[0]['truckNomination'] = 0;
        target[0]['railNomination'] = 0;
        target[0]['pptcdewNomination'] = 0;
        target[0]['trsfOutto15Nomination'] = 0;
        target[0]['reinjectionEstimates'] = 0;
        target[0]['gainLossEstimates'] = 0;

        if (gridData.length > 0) {
            gridData.forEach((rowNode, index) => {
                target[0]['openingInvActuals'] = this.chkChng(target[0]['openingInvActuals']);
                if (new Date(rowNode['referrenceDate']) >= now) {
                    target[0]['productionEstimates'] = this.chkChng(target[0]['productionEstimates'])
                        + Number(parseFloat((((this.chkChng(rowNode.e6nomination) / 28.327)
                            * (this.chkChng(rowNode.nglyieldBblsMmcf) / 6.29287))
                            + this.chkChng(rowNode.trsfInfromE1e5toE6nomination) + this.chkChng(rowNode.trsfInfromE1toE6nomination)
                            + this.chkChng(rowNode.ngltruckOffloadNomination) + this.chkChng(rowNode.nglrailOffloadNomination)
                            + this.chkChng(rowNode.ngltruckLoadingNomination) + this.chkChng(rowNode.nglrailLoadingNomination))
                            * this.chkChng(rowNode.compositionPercent) / 100).toFixed(2));
                    target[0]['offspecRerunEstimates'] = this.chkChng(target[0]['offspecRerunEstimates']) + this.chkChng(rowNode.offspecRerunEstimates);
                    target[0]['truckNomination'] = this.chkChng(target[0]['truckNomination']) + this.chkChng(rowNode.truckNomination);
                    target[0]['railNomination'] = this.chkChng(target[0]['railNomination']) + this.chkChng(rowNode.railNomination);
                    target[0]['pptcdewNomination'] = this.chkChng(target[0]['pptcdewNomination']) + this.chkChng(rowNode.pptcdewNomination);
                    target[0]['trsfOutto15Nomination'] = this.chkChng(target[0]['trsfOutto15Nomination']) + this.chkChng(rowNode.trsfOutto15Nomination);
                    target[0]['reinjectionEstimates'] = this.chkChng(target[0]['reinjectionEstimates']) + this.chkChng(rowNode.reinjectionEstimates);
                    target[0]['gainLossEstimates'] = this.chkChng(target[0]['gainLossEstimates']) + this.chkChng(rowNode.gainLossEstimates);
                } else {
                    target[0]['productionEstimates'] = this.chkChng(target[0]['productionEstimates']) + this.chkChng(rowNode.productionActuals);
                    target[0]['offspecRerunEstimates'] = this.chkChng(target[0]['offspecRerunEstimates']) + this.chkChng(rowNode.offspecRerunActuals);
                    target[0]['truckNomination'] = this.chkChng(target[0]['truckNomination']) + this.chkChng(rowNode.truckActuals);
                    target[0]['railNomination'] = this.chkChng(target[0]['railNomination']) + this.chkChng(rowNode.railActuals);
                    target[0]['pptcdewNomination'] = this.chkChng(target[0]['pptcdewNomination']) + this.chkChng(rowNode.pptcdewActuals);
                    target[0]['trsfOutto15Nomination'] = this.chkChng(target[0]['trsfOutto15Nomination']) + this.chkChng(rowNode.trsfOutto15Actuals);
                    target[0]['reinjectionEstimates'] = this.chkChng(target[0]['reinjectionEstimates']) + this.chkChng(rowNode.reinjectionActuals);
                    target[0]['gainLossEstimates'] = this.chkChng(target[0]['gainLossEstimates']) + this.chkChng(rowNode.gainLossActuals);
                }
                if (index == (rowCount - 1)) {
                    if (new Date(rowNode['referrenceDate']) > new Date())
                        target[0]['closingRailcarInvEstimates'] = this.chkChng(rowNode.closingRailcarInvEstimates);
                    else
                        target[0]['closingRailcarInvEstimates'] = this.chkChng(rowNode.closingRailcarInvActuals);
                }
            });

            target[0]['closingTankInvEstimates'] = (this.chkChng(target[0]['openingInvEstimates'])
                + this.chkChng(target[0]['productionEstimates']) + this.chkChng(target[0]['offspecRerunEstimates'])
                + this.chkChng(target[0]['truckNomination']) + this.chkChng(target[0]['railNomination'])
                + this.chkChng(target[0]['pptcdewNomination']) + this.chkChng(target[0]['trsfOutto15Nomination'])
                + this.chkChng(target[0]['reinjectionEstimates']) + this.chkChng(target[0]['gainLossEstimates'])
            ) - (this.chkChng(target[0]['closingRailcarInvEstimates']))

            target[2]['productionEstimates'] = this.chkChng(target[0]['productionEstimates']) - this.chkChng(target[1]['productionEstimates']);
            target[2]['offspecRerunEstimates'] = this.chkChng(target[0]['offspecRerunEstimates']) - this.chkChng(target[1]['offspecRerunEstimates']);
            target[2]['truckNomination'] = this.chkChng(target[0]['truckNomination']) - this.chkChng(target[1]['truckNomination']);
            target[2]['railNomination'] = this.chkChng(target[0]['railNomination']) - this.chkChng(target[1]['railNomination']);
            target[2]['pptcdewNomination'] = this.chkChng(target[0]['pptcdewNomination']) - this.chkChng(target[1]['pptcdewNomination']);
            target[2]['trsfOutto15Nomination'] = this.chkChng(target[0]['trsfOutto15Nomination']) - this.chkChng(target[1]['trsfOutto15Nomination']);
            target[2]['reinjectionEstimates'] = this.chkChng(target[0]['reinjectionEstimates']) - this.chkChng(target[1]['reinjectionEstimates']);
            target[2]['gainLossEstimates'] = this.chkChng(target[0]['gainLossEstimates']) - this.chkChng(target[1]['gainLossEstimates']);
        }
        return target;
    }
    calculateCondensate(target, gridData, openAttribute) {
        var rowCount = gridData.length;
        let now = new Date(momenttimezone.tz(
            moment.utc(new Date()),
            AppConstants.MT_TIME_FORMATTER
        ).format('YYYY-MM-DDT00:00:00'));

        target[1]['openingInvEstimates'] = ''; target[2]['openingInvEstimates'] = '';

        target[0]['openingInvActuals'] = ''; target[1]['openingInvActuals'] = ''; target[2]['openingInvActuals'] = '';
        target[0]['offspecRerunActuals'] = ''; target[1]['offspecRerunActuals'] = ''; target[2]['offspecRerunActuals'] = '';
        target[0]['truckActuals'] = ''; target[1]['truckActuals'] = ''; target[2]['truckActuals'] = '';
        target[0]['trsfOutto15Actuals'] = ''; target[1]['trsfOutto15Actuals'] = ''; target[2]['trsfOutto15Actuals'] = '';
        target[0]['reinjectionActuals'] = ''; target[1]['reinjectionActuals'] = ''; target[2]['reinjectionActuals'] = '';
        target[0]['gainLossActuals'] = ''; target[1]['gainLossActuals'] = ''; target[2]['gainLossActuals'] = '';

        target[1]['closingRailcarInvEstimates'] = ''; target[2]['closingRailcarInvEstimates'] = '';

        target[1]['closingTankInvEstimates'] = ''; target[2]['closingTankInvEstimates'] = '';

        target[0]['maxStorageM3'] = ''; target[1]['maxStorageM3'] = ''; target[2]['maxStorageM3'] = '';

        target[0]['percentofSafeLevelEstimates'] = null; target[1]['percentofSafeLevelEstimates'] = null; target[2]['percentofSafeLevelEstimates'] = null;

        target[0]['percentofSafeLevelActuals'] = null; target[1]['percentofSafeLevelActuals'] = null; target[2]['percentofSafeLevelActuals'] = null;

        target[1]['updatedBy'] = ''; target[1]['updatedOn'] = '';

        target[0]['openingInvEstimates'] = openAttribute; target[0]['productionEstimates'] = 0;
        target[0]['offspecRerunEstimates'] = 0; target[0]['truckNomination'] = 0;
        target[0]['trsfOutto15Nomination'] = 0; target[0]['reinjectionEstimates'] = 0; target[0]['gainLossEstimates'] = 0;

        if (gridData.length > 0) {
            gridData.forEach((rowNode, index) => {
                if (new Date(rowNode['referrenceDate']) >= now) {
                    target[0]['productionEstimates'] = this.chkChng(target[0]['productionEstimates'])
                        + Number(parseFloat((((this.chkChng(rowNode.e6nomination) / 28.327) * (this.chkChng(rowNode.nglyieldBblsMmcf) / 6.29287))
                            + this.chkChng(rowNode.trsfInfromE1e5toE6nomination) + this.chkChng(rowNode.trsfInfromE1toE6nomination)
                            + this.chkChng(rowNode.ngltruckOffloadNomination) + this.chkChng(rowNode.nglrailOffloadNomination)
                            + this.chkChng(rowNode.ngltruckLoadingNomination) + this.chkChng(rowNode.nglrailLoadingNomination))
                            * (100 - rowNode.propaneComposition - rowNode.butaneComposition - rowNode.isoButaneComposition
                                - rowNode.normalButaneComposition) / 100).toFixed(2));
                    target[0]['offspecRerunEstimates'] = this.chkChng(target[0]['offspecRerunEstimates']) + this.chkChng(rowNode.offspecRerunEstimates);
                    target[0]['truckNomination'] = this.chkChng(target[0]['truckNomination']) + this.chkChng(rowNode.truckNomination);
                    target[0]['trsfOutto15Nomination'] = this.chkChng(target[0]['trsfOutto15Nomination']) + this.chkChng(rowNode.trsfOutto15Nomination);
                    target[0]['reinjectionEstimates'] = this.chkChng(target[0]['reinjectionEstimates']) + this.chkChng(rowNode.reinjectionEstimates);
                    target[0]['gainLossEstimates'] = this.chkChng(target[0]['gainLossEstimates']) + this.chkChng(rowNode.gainLossEstimates);
                } else {
                    target[0]['productionEstimates'] = this.chkChng(target[0]['productionEstimates']) + this.chkChng(rowNode.productionActuals);
                    target[0]['offspecRerunEstimates'] = this.chkChng(target[0]['offspecRerunEstimates']) + this.chkChng(rowNode.offspecRerunActuals);
                    target[0]['truckNomination'] = this.chkChng(target[0]['truckNomination']) + this.chkChng(rowNode.truckActuals);
                    target[0]['trsfOutto15Nomination'] = this.chkChng(target[0]['trsfOutto15Nomination']) + this.chkChng(rowNode.trsfOutto15Actuals);
                    target[0]['reinjectionEstimates'] = this.chkChng(target[0]['reinjectionEstimates']) + this.chkChng(rowNode.reinjectionActuals);
                    target[0]['gainLossEstimates'] = this.chkChng(target[0]['gainLossEstimates']) + this.chkChng(rowNode.gainLossActuals);
                }
                if (index == (rowCount - 1)) {
                    if (new Date(rowNode['referrenceDate']) > new Date())
                        target[0]['closingRailcarInvEstimates'] = this.chkChng(rowNode.closingRailcarInvEstimates);
                    else
                        target[0]['closingRailcarInvEstimates'] = this.chkChng(rowNode.closingRailcarInvActuals);
                }
            });

            target[0]['closingTankInvEstimates'] = (this.chkChng(target[0]['openingInvEstimates'])
                + this.chkChng(target[0]['productionEstimates']) + this.chkChng(target[0]['offspecRerunEstimates'])
                + this.chkChng(target[0]['truckNomination']) + this.chkChng(target[0]['trsfOutto15Nomination'])
                + this.chkChng(target[0]['reinjectionEstimates']) + this.chkChng(target[0]['gainLossEstimates'])
            ) - (this.chkChng(target[0]['closingRailcarInvEstimates']));

            target[2]['productionEstimates'] = this.chkChng(target[0]['productionEstimates']) - this.chkChng(target[1]['productionEstimates']);
            target[2]['offspecRerunEstimates'] = this.chkChng(target[0]['offspecRerunEstimates']) - this.chkChng(target[1]['offspecRerunEstimates']);
            target[2]['truckNomination'] = this.chkChng(target[0]['truckNomination']) - this.chkChng(target[1]['truckNomination']);
            target[2]['trsfOutto15Nomination'] = this.chkChng(target[0]['trsfOutto15Nomination']) - this.chkChng(target[1]['trsfOutto15Nomination']);
            target[2]['reinjectionEstimates'] = this.chkChng(target[0]['reinjectionEstimates']) - this.chkChng(target[1]['reinjectionEstimates']);
            target[2]['gainLossEstimates'] = this.chkChng(target[0]['gainLossEstimates']) - this.chkChng(target[1]['gainLossEstimates']);
        }
        return target;
    }

    async generatePinnedBottomData(props, rawdata, gridOpts, customFacility) {
        let result = {};

        gridOpts.columnApi.getAllGridColumns().forEach(item => {
            result[item.colId] = null;
        });

        let selectedMonth = moment(this.props?.selectedMnthOption).format('MMM-YYYY');
        let nominationRole = this.state.nominationRole;
        let now = momenttimezone.tz(moment.utc(new Date()), AppConstants.MT_TIME_FORMATTER);
        let nextOneEightAM = moment('01-' + selectedMonth + ' 08:00:00',
            'DD-MMM-YYYY HH:mm:ss', AppConstants.MT_TIME_FORMATTER).add(1, 'M');
        let footerItems = [];
        let UOMDivision = this.props.selectedUOM?.division;
        let UOMUnit = this.props.selectedUOM?.value;
        let overUnderViewON = this.state?.overUnderViewON;

        result['gridIndicators'] = (nextOneEightAM > now)
            + '|' + nominationRole + '|' + this.state.assetViewON + '|||||' + UOMDivision + '|' + UOMUnit + '|' + overUnderViewON;
        const fact = customFacility || props?.selectedFacOption;
        let nominationItems = footerJson.faclitiesProducts.filter(
            (opt) => opt.fact == fact.value);
        if (nominationItems.length > 0 && nominationItems[0].footer != null) {
            nominationItems[0].footer[0].forEach((item) => {
                result[item.field] = item.text;
            });
            footerItems.push(result);
            if (nominationItems[0].footer.length > 1) {
                nominationItems[0].footer.slice(1).forEach((nominationItem) => {
                    let shallow = Object.assign({}, result);
                    nominationItem.forEach((item) => {
                        shallow[item.field] = item.text;
                    });
                    footerItems.push(shallow);
                });
            }
        }
        if (rawdata != null) {
            return footerItems.map(obj => {
                if (obj.date == rawdata.date) {
                    let indicator = obj.product;
                    let clone = { ...obj, ...rawdata };
                    clone.product = indicator;
                    return clone;
                } else
                    return { ...obj };
            });
        } else {
            return footerItems;
        }
    }

    getHiddenGridsData = async (superProps) => {
        const {
            overUnderViewON,
            butaneGridOptions,
            isoButaneGridOptions,
            normalButaneGridOptions,
            propaneGridOptions,
            condensateGridOptions
        } = this.state
        const { nominationRole, selectedUOM, selectedMnthOption } = superProps
        let selectedMonth = moment(selectedMnthOption).format('MMM-YYYY')
        const {
            rawButaneData, rawIsoButaneDta, rawNormalButaneData,
            rawPropaneData, rawCondensateData
        } = await NominationScreenStore.getAllData(selectedMonth)

        this.state.propaneGridOptions.api.setColumnDefs([]);
        this.state.propaneGridOptions.api.setRowData([]);
        this.state.propaneGridOptions.api.expireValueCache();

        this.state.butaneGridOptions.api.setColumnDefs([]);
        this.state.butaneGridOptions.api.setRowData([]);
        this.state.butaneGridOptions.api.expireValueCache();

        this.state.isoButaneGridOptions.api.setColumnDefs([]);
        this.state.isoButaneGridOptions.api.setRowData([]);
        this.state.isoButaneGridOptions.api.expireValueCache();

        this.state.normalButaneGridOptions.api.setColumnDefs([]);
        this.state.normalButaneGridOptions.api.setRowData([]);
        this.state.normalButaneGridOptions.api.expireValueCache();

        this.state.condensateGridOptions.api.setColumnDefs([]);
        this.state.condensateGridOptions.api.setRowData([]);
        this.state.condensateGridOptions.api.expireValueCache();

        let adjustUnit = 0;
        let grids = {}
        const customProps = {
            superProps, rawPropaneData, rawButaneData, rawIsoButaneDta, rawNormalButaneData,
            rawCondensateData, chkChng: this.chkChng
        }
        const rowsData = getRows(customProps)
        const footers = getFooters(customProps)
        const backData = getOlds(customProps)
        const opens = getOpens({ ...customProps, ...backData })
        
        const hiddenGridProps = {
            selectedMonth,
            overUnderViewON,
            adjustUnit,
            nomRole: nominationRole,
            selectedUOM,
            footers,
            opens,
            rowsData
        }
        grids = getHiddenGridsData(hiddenGridProps)

        const {
            butaneColDefs, condensateColDefs, isoButaneColDefs,
            normalButaneColDefs, propaneColDefs
        } = getColumnDefitions(this.props)

        butaneGridOptions.api.setColumnDefs(butaneColDefs)
        isoButaneGridOptions.api.setColumnDefs(isoButaneColDefs)
        normalButaneGridOptions.api.setColumnDefs(normalButaneColDefs)
        propaneGridOptions.api.setColumnDefs(propaneColDefs)
        condensateGridOptions.api.setColumnDefs(condensateColDefs)

        const pinnedBottomProps = {
            superProps,
            generatePinnedBottomData: this.generatePinnedBottomData.bind(this),
            calculatePinnedBottomData: this.calculatePinnedBottomData.bind(this),
            propaneGridOptions,
            butaneGridOptions,
            isoButaneGridOptions,
            normalButaneGridOptions,
            condensateGridOptions,
            footers,
            backData,
            opens,
            rowsData
        }

        const {
            propanePinnedBottomData,
            butanePinnedBottomData,
            isoButanePinnedBottomData,
            normalButanePinnedBottomData,
            condensatePinnedBottomData
        } = await getPinnedBottoms(pinnedBottomProps)

        propaneGridOptions.api.setPinnedBottomRowData(propanePinnedBottomData)
        butaneGridOptions.api.setPinnedBottomRowData(butanePinnedBottomData)
        isoButaneGridOptions.api.setPinnedBottomRowData(isoButanePinnedBottomData)
        normalButaneGridOptions.api.setPinnedBottomRowData(normalButanePinnedBottomData)
        condensateGridOptions.api.setPinnedBottomRowData(condensatePinnedBottomData)

        let propaneData = grids.propane?.data || []
        let butaneData = grids?.butane?.data || []
        let isoButaneData = grids.isoButane?.data || []
        let normalButaneData = grids.normalButane?.data || []
        let condensateData = grids.condensate?.data || []

        this.state.propaneGridOptions.api.setRowData(propaneData);
        this.state.propaneGridOptions.api.refreshCells({ force: true, suppressFlash: true });
        this.state.butaneGridOptions.api.setRowData(butaneData);
        this.state.butaneGridOptions.api.refreshCells({ force: true, suppressFlash: true });
        this.state.isoButaneGridOptions.api.setRowData(isoButaneData);
        this.state.isoButaneGridOptions.api.refreshCells({ force: true, suppressFlash: true });
        this.state.normalButaneGridOptions.api.setRowData(normalButaneData);
        this.state.normalButaneGridOptions.api.refreshCells({ force: true, suppressFlash: true });
        this.state.condensateGridOptions.api.setRowData(condensateData);
        this.state.condensateGridOptions.api.refreshCells({ force: true, suppressFlash: true });
        this.setState({
            propaneData,
            butaneData,
            isoButaneData,
            normalButaneData,
            condensateData
        })
    }

    getColDefWithTooltip = (nmntnColDef, selectedMonth, selectedFact) => {
        const colName = this.props.screenDetails.screenColumns.find((i) => i.rowKey === selectedFact)?.rowKey;
        if(selectedMonth){
            const isMonthAprOrGreater = moment(new Date(selectedMonth)).month() > 3; // Jan = 0
            const isYear2024OrGreater = moment(new Date(selectedMonth)).year() >= 2024;
            if (nmntnColDef.length > 0 && ((isMonthAprOrGreater && isYear2024OrGreater) ||
                (moment(new Date(selectedMonth)).year() > 2024))) {
                nmntnColDef.forEach(item => {
                    switch(colName) {
                        case 'NGL':
                        if (item.headerName === "Trsf-In from E1-E5 to E6 Actuals") {
                            item['headerTooltip'] = 'FlowCal Meter: EMS09410VSCIMNGL';
                        } 
                        else if (item.headerName === "Trsf-In from E1 to E6 Actuals") {
                            item['headerTooltip'] = 'FlowCal Meter: EM1000095SCIMNGL';
                            }
                            break;
                        case 'Propane':
                            if ("Trsf Out to 1-5 Actuals" === item.headerName) {
                                item['headerTooltip'] = 'FlowCal Meter: EMS000096SCIPROP';
                            }
                            break;
                        case 'Butane':
                            if ("Trsf Out to 1-5 Actuals" === item.headerName) {
                                item['headerTooltip'] = 'FlowCal Meter: EMS000097SCIFBUT  +  EMS000096SCIFBUT';
                            }
                            break;
                            case 'Iso-Butane':
                                if ("Trsf Out to 1-5 Actuals" === item.headerName) {
                                    item['headerTooltip'] = 'FlowCal Meter: EMS000097SCIIBUT';
                            }
                            break;
                        case 'Normal Butane':
                            if ("Trsf Out to 1-5 Actuals" === item.headerName) {
                                item['headerTooltip'] = 'FlowCal Meter: EMS000097SCINBUT';
                            }
                            break;
                        case 'Condensate':
                            if ("Trsf Out to 1-5 Actuals" === item.headerName) {
                                item['headerTooltip'] = 'FlowCal Meter: EMS000097SCICOND';
                            }
                            break;
                        case 'Kerrobert':
                            if ("NGL To Kerrobert Actuals" === item.headerName) {
                                item['headerTooltip'] = 'FlowCal Meter: KPL000084SCIMNGL + KPL000085SCIMNGL';
                            }
                            break;
                        default:
                            break;
                    }
                });
            }
        }

        return nmntnColDef
    }

    getGridData = async (superProps) => {
        var selectedFact = superProps.selectedFacOption.value;
        let selectedMonth = moment(superProps.selectedMnthOption).format('MMM-YYYY');
        let rawdata =
            await NominationScreenStore.getNominationData(
                selectedFact, selectedMonth, superProps.CommonStore);

        let footerRaw = (typeof rawdata?.footer !== 'undefined' && rawdata?.footer != null
            && Object.keys(rawdata.footer).length > 0 ? rawdata.footer : {});
        let adjustUnit = 0;
        if (superProps.updateAdjustment) {
            adjustUnit = superProps.adjustmentEdit;
            let adjustmentData = {
                Id: (footerRaw?.id), ReferrenceDate: (footerRaw?.referrenceDate), Fact: selectedFact,
                FieldRef: "unit", Value: adjustUnit, Editor: this.state?.displayName
            }
            await NominationScreenStore.saveNominationData(adjustmentData);
            superProps.updateAdjustInv(adjustUnit);
        } else {
            adjustUnit = footerRaw?.unit;
            if (typeof adjustUnit == 'undefined' || adjustUnit == null || isNaN(adjustUnit.toString())) {
                adjustUnit = 0;
            }
            superProps.updateAdjustInv(adjustUnit);
        }
        this.state.gridOptions.api.setColumnDefs([]);
        this.state.gridOptions.api.setRowData([]);
        this.state.gridOptions.api.expireValueCache();
        let backData = (typeof rawdata?.backData !== 'undefined' && rawdata?.backData != null
            && Object.keys(rawdata.backData).length > 0 ? rawdata.backData : {});

        let nmntnData = (typeof rawdata?.data !== 'undefined'
            && Object.keys(rawdata.data).length > 0 ? rawdata.data : {});

        let selectedDef = {};
        try {
            const colDef = superProps.screenDetails.screenColumns.find((i) => i.rowKey === selectedFact);
            let name = (typeof colDef.name !== 'undefined' && colDef.name != null ? (colDef.name).trim() : '');
            let title = (typeof colDef.title !== 'undefined' && colDef.title != null ? (colDef.title).trim() : "");
            let concatDef = String(name) + String(title);

            selectedDef = JSON.parse(atob(concatDef));
        } catch (e) { }

        let nmntnColDef = selectedDef.map((item) => {
            return Object.entries(item).reduce((pre, [key, value]) => {
                if (typeof value === "string" && value.startsWith("/Function(") && value.endsWith(")/")) {
                    value = value.substring(10, value.length - 2); pre[key] = (0, eval)("(" + value + ")");
                } else { pre[key] = value; } return pre
            }, {})
        });
        nmntnColDef = this.getColDefWithTooltip(nmntnColDef, selectedMonth, selectedFact)
        this.state.gridOptions.api.setColumnDefs(nmntnColDef);

        let now = moment().tz(AppConstants.MT_TIME_FORMATTER);
        let nextMonthSixth = moment('06-' + selectedMonth + ' 00:00:01',
            'DD-MMM-YYYY HH:mm:ss', AppConstants.MT_TIME_FORMATTER).add(1, 'M');
        let nominationRole = superProps.nominationRole;
        let currentMonth = moment('01-' + selectedMonth + ' 00:00:01',
            'DD-MMM-YYYY HH:mm:ss', AppConstants.MT_TIME_FORMATTER);
        let UOMDivision = superProps.selectedUOM?.division;
        let UOMUnit = superProps.selectedUOM?.value;
        let overUnderViewON = this.state.overUnderViewON;

        let openEst = 0; let openAct = 0; let openAttribute = 0;
        if (['Propane', 'Butane', 'Iso-Butane',
            'Normal Butane', 'Condensate'].includes(selectedFact)) {
            openEst = this.chkChng(backData?.closingRailcarInvEstimates)
                + this.chkChng(backData?.closingTankInvEstimates);
            openAct = this.chkChng(backData?.closingRailcarInvActuals)
                + this.chkChng(backData?.closingTankInvEstimates);
            openAttribute =
                (moment(superProps.selectedMnthOption) > moment() ? openEst : openAct);
        }

        let pinnedBottomData = await this.generatePinnedBottomData(superProps, footerRaw, this.state.gridOptions);
        pinnedBottomData = await this.calculatePinnedBottomData(
            pinnedBottomData, nmntnData, (Number(openAttribute) + Number(adjustUnit)));
        this.gridApi.setPinnedBottomRowData(pinnedBottomData);
        let gridIndicators = (now.hour() >= 8 ? now.format('DD-MMM-YYYY') : now.add(-1, 'd').format('DD-MMM-YYYY'))
            + '|' + nominationRole + '|' + adjustUnit
            + '|' + (now <= nextMonthSixth) + '|' + (now <= currentMonth)
            + '|' + openEst + '|' + openAct + '|' + UOMDivision + '|' + UOMUnit + '|' + overUnderViewON;

        const gridData = Object.keys(nmntnData).length > 0 ? (nmntnData.map(obj => ({ ...obj, "gridIndicators": gridIndicators }))) : {};

        this.state.gridOptions.api.setRowData(gridData);
        this.state.gridOptions.api.refreshCells({ force: true, suppressFlash: true });
        this.setState({
            nmntnData: gridData,
            nmntnColDef: nmntnColDef,
            gridIndicators: gridIndicators,
            footerItems: pinnedBottomData,
            isDirty: true,
            openAttribute: (Number(openAttribute) + Number(adjustUnit)),
            overUnderViewON: false,
            assetViewON: false,
            nominationViewON: false,
            actualsViewON: false
        });
    }

    componentDidMount() {
        if (this.props.superDirty) this.getGridData(this.props);
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.superDirty) this.getGridData(nextProps);
    }
    onPasteStart = async (e) => {
        this.setState({ isPasting: true });
    }
    onPasteEnd = async (e) => {
        const { nmntnData, footerItems } = this.state;
        e.api.setPinnedBottomRowData(footerItems);
        e.api.setRowData(nmntnData);
        this.setState({ isPasting: false });
    }
    onCellValueChanged = async (e) => {
        e.api.expireValueCache();
        e.api.refreshCells({ force: true });

        var oldVal = (typeof e.oldValue != 'undefined' && e.oldValue) ? e.oldValue : null;
        var newVal = (typeof e.newValue != 'undefined' && e.newValue) ? e.newValue : null;
        if (newVal != oldVal) {
            if (this.state.isPasting) {
                var selectedFact = this.props?.selectedFacOption?.value;
                let rIndx = 0;
                let newData = {
                    Id: e?.data?.id, ReferrenceDate: e?.data?.referrenceDate,
                    Fact: selectedFact, FieldRef: e?.colDef?.field,
                    Value: e.newValue, Editor: this.state?.displayName
                }
                let rows = [];
                e.api.forEachNodeAfterFilterAndSort((rowNode) => {
                    if (rowNode.data.id == e?.data?.id) {
                        rIndx = Number(rowNode.id);
                        rowNode.data.updatedBy = this.state?.displayName;
                        rowNode.data.updatedOn =
                            new Date().toLocaleString('en-US', { timeZone: AppConstants.MT_TIME_FORMATTER });
                    }
                    rows.push(rowNode.data);
                });
                let pinnedBottomData = await this.calculatePinnedBottomData(null, rows, null);
                this.setState({ nmntnData: rows, footerItems: pinnedBottomData, dirtyRowIndx: rIndx });
                e.api.ensureIndexVisible(rIndx, 'middle');

                await NominationScreenStore.saveNominationData(newData);
            } else if ((!this.state.isDirty) && (e.oldValue != e.newValue)) {
                this.setState({ isDirty: true });
            }
        }
    }
    onCellEditingStopped = async (e) => {
        if (this.state.isDirty) {
            var selectedFact = this.props?.selectedFacOption?.value;
            let rIndx = 0;
            let newData = {
                Id: e?.data?.id, ReferrenceDate: e?.data?.referrenceDate,
                Fact: selectedFact, FieldRef: e?.colDef?.field,
                Value: e.value, Editor: this.state?.displayName
            }
            await NominationScreenStore.saveNominationData(newData);

            let rows = [];
            e.api.forEachNodeAfterFilterAndSort(async (rowNode) => {
                if (rowNode.data.id == e?.data?.id) {
                    rIndx = Number(rowNode.id);
                    rowNode.data.updatedBy = this.state?.displayName;
                    rowNode.data.updatedOn =
                        new Date().toLocaleString('en-US', { timeZone: AppConstants.MT_TIME_FORMATTER });
                }
                rows.push(rowNode.data);
            });
            let pinnedBottomData = await this.calculatePinnedBottomData(null, rows, null);
            e.api.setPinnedBottomRowData(pinnedBottomData);
            e.api.setRowData(rows);
            e.api.ensureIndexVisible(rIndx, 'middle');
            this.setState({
                isDirty: false
            });
        }
    }
    assetView = () => {
        let { nmntnColDef, footerItems, assetViewON, overUnderViewON, nominationViewON, actualsViewON } = this.state;
        if (overUnderViewON) {
            nmntnColDef.map(col => {
                if ((!['id', 'commentsAssetLogistics', 'commentsBypass', 'date', 'facilityPipeline',
                    'nominationNotMetReasons', 'plannedOutage', 'product', 'unplannedOutage', 'updatedBy',
                    'updatedOn'].includes(col.field)) && (!col.headerName.includes('Over/(Under)'))) {
                    col.hide = false;
                }
            });
        }
        if (nominationViewON) {
            nmntnColDef.map(col => {
                if ((!['id', 'commentsAssetLogistics', 'date', 'facilityPipeline',
                    'plannedOutage', 'product', 'unplannedOutage', 'unit', 'updatedBy', 'updatedOn'
                ].includes(col.field)) &&
                    !(col.headerName.includes('Nomination') || col.headerName.includes('Estimates'))) {
                    col.hide = false;
                }
                if (['commentsBypass', 'nominationNotMetReasons', 'e1reinjectionActuals',
                    'e1reinjectionEstimate', 'e2reinjectionActuals', 'e2reinjectionEstimate',
                    'e5reinjectionActuals', 'e5reinjectionEstimate', 'e6reinjectionActuals',
                    'e6reinjectionEstimate'].includes(col.field)) {
                    col.hide = false
                }
            });
        }
        if (actualsViewON) {
            nmntnColDef.map(col => {
                if ((!['id', 'commentsAssetLogistics', 'commentsBypass', 'date', 'facilityPipeline',
                    'plannedOutage', 'product', 'unplannedOutage', 'unit', 'updatedBy',
                    'updatedOn'].includes(col.field)) && !(col.headerName.includes('Actuals'))) {
                    col.hide = false;
                }
            });
        }
        assetViewON = !(assetViewON);
        nmntnColDef.map(col => {
            if (col.headerName.includes('Over/(Under)')) { col.hide = assetViewON; }
        });
        this.state.gridOptions.api.setColumnDefs([]);
        this.state.gridOptions.api.setColumnDefs(nmntnColDef);
        this.state.gridOptions.api.setPinnedBottomRowData(footerItems);
        this.setState({
            nmntnColDef: nmntnColDef, assetViewON: assetViewON, actualsViewON: false,
            overUnderViewON: false, nominationViewON: false, footerItems: footerItems
        });
    }
    overUnderView = () => {
        let { nmntnColDef, footerItems, assetViewON, overUnderViewON, nominationViewON, actualsViewON } = this.state;
        if (assetViewON) {
            nmntnColDef.map(col => {
                if (col.headerName.includes('Over/(Under)')) { col.hide = false; }
            });
        }
        if (nominationViewON) {
            nmntnColDef.map(col => {
                if ((!['id', 'commentsAssetLogistics', 'date', 'facilityPipeline',
                    'plannedOutage', 'product', 'unplannedOutage',
                    'unit', 'updatedBy', 'updatedOn'].includes(col.field)) &&
                    !(col.headerName.includes('Nomination') || col.headerName.includes('Estimates'))) {
                    col.hide = false;
                }
                if (['commentsBypass', 'nominationNotMetReasons', 'e1reinjectionActuals',
                    'e1reinjectionEstimate', 'e2reinjectionActuals', 'e2reinjectionEstimate',
                    'e5reinjectionActuals', 'e5reinjectionEstimate', 'e6reinjectionActuals',
                    'e6reinjectionEstimate'].includes(col.field)) {
                    col.hide = false
                }
            });
        }
        if (actualsViewON) {
            nmntnColDef.map(col => {
                if ((!['id', 'commentsAssetLogistics', 'date', 'facilityPipeline',
                    'plannedOutage', 'product', 'unplannedOutage', 'unit', 'updatedBy',
                    'updatedOn'].includes(col.field)) && !(col.headerName.includes('Actuals'))) {
                    col.hide = false;
                }
            });
        }
        overUnderViewON = !(overUnderViewON);
        nmntnColDef.map(col => {
            if ((!['id', 'commentsAssetLogistics', 'commentsBypass', 'date', 'facilityPipeline',
                'nominationNotMetReasons', 'plannedOutage', 'product', 'unplannedOutage',
                'unit', 'updatedBy', 'updatedOn'].includes(col.field))
                && (!col.headerName.includes('Over/(Under)'))) {
                col.hide = overUnderViewON;
            }
        });
        this.state.gridOptions.api.setColumnDefs([]);
        this.state.gridOptions.api.setColumnDefs(nmntnColDef);
        this.state.gridOptions.api.setPinnedBottomRowData(footerItems);
        this.setState({
            nmntnColDef: nmntnColDef, assetViewON: false, actualsViewON: false,
            overUnderViewON: overUnderViewON, nominationViewON: false, footerItems: footerItems
        });
    }
    nominationView = () => {
        let { nmntnColDef, footerItems, assetViewON, overUnderViewON, nominationViewON, actualsViewON } = this.state;
        if (assetViewON) {
            nmntnColDef.map(col => {
                if (col.headerName.includes('Over/(Under)')) { col.hide = false; }
            });
        }
        if (overUnderViewON) {
            nmntnColDef.map(col => {
                if ((!['id', 'commentsAssetLogistics', 'commentsBypass', 'date',
                    'facilityPipeline', 'nominationNotMetReasons', 'plannedOutage', 'product',
                    'unplannedOutage', 'updatedBy', 'updatedOn'].includes(col.field)) &&
                    (!col.headerName.includes('Over/(Under)'))) {
                    col.hide = false;
                }
            });
        }
        if (actualsViewON) {
            nmntnColDef.map(col => {
                if ((!['id', 'commentsAssetLogistics', 'commentsBypass', 'date', 'facilityPipeline',
                    'nominationNotMetReasons', 'plannedOutage', 'product', 'unplannedOutage',
                    'unit', 'updatedBy', 'updatedOn'].includes(col.field))
                    && !(col.headerName.includes('Actuals'))) {
                    col.hide = false;
                }
            });
        }

        nominationViewON = !(nominationViewON)
        // No pinned footer in nomination view
        const pinnedBottomData = nominationViewON ? [] : footerItems
        nmntnColDef.map(col => {
            if ((!['id', 'commentsAssetLogistics', 'date', 'facilityPipeline', 'plannedOutage',
                'product', 'unplannedOutage', 'unit', 'updatedBy', 'updatedOn', 'e1targetOrMax',
                'e2targetOrMax', 'e5targetOrMax', 'e6targetOrMax', 'compositionPercent',
                'maxStorageM3'].includes(col.field)) &&
                !(col.headerName.includes('Nomination') || col.headerName.includes('Estimates'))) {
                col.hide = nominationViewON;
            }
            if (['nominationNotMetReasons', 'e1reinjectionActuals', 'e1reinjectionEstimate',
                'e2reinjectionActuals', 'e2reinjectionEstimate', 'e5reinjectionActuals',
                'e5reinjectionEstimate', 'e6reinjectionActuals', 'e6reinjectionEstimate'
            ].includes(col.field)) {
                col.hide = nominationViewON;
            }
        });

        this.state.gridOptions.api.setColumnDefs([]);
        this.state.gridOptions.api.setColumnDefs(nmntnColDef);
        this.state.gridOptions.api.setPinnedBottomRowData(pinnedBottomData);
        this.setState({
            nmntnColDef: nmntnColDef, assetViewON: false, actualsViewON: false,
            overUnderViewON: false, nominationViewON: nominationViewON, footerItems: footerItems
        });
    }
    actualsView = async () => {
        let { nmntnColDef, footerItems, assetViewON, overUnderViewON, nominationViewON, actualsViewON } = this.state;

        if (assetViewON) {
            nmntnColDef.map(col => {
                if (col.headerName.includes('Over/(Under)')) { col.hide = false; }
            });
        }
        if (overUnderViewON) {
            nmntnColDef.map(col => {
                if ((!['id', 'commentsAssetLogistics', 'commentsBypass', 'date',
                    'facilityPipeline', 'nominationNotMetReasons', 'plannedOutage', 'product',
                    'unplannedOutage', 'updatedBy', 'updatedOn'].includes(col.field)) &&
                    (!col.headerName.includes('Over/(Under)'))) {
                    col.hide = false;
                }
            });
        }
        if (nominationViewON) {
            nmntnColDef.map(col => {
                if ((!['id', 'commentsAssetLogistics', 'date', 'facilityPipeline',
                    'nominationNotMetReasons', 'plannedOutage', 'product', 'unplannedOutage', 'unit',
                    'updatedBy', 'updatedOn'].includes(col.field)) &&
                    !(col.headerName.includes('Nomination') || col.headerName.includes('Estimates'))) {
                    col.hide = false;
                }
                if (['nominationNotMetReasons', 'e1reinjectionActuals', 'e1reinjectionEstimate',
                    'e2reinjectionActuals', 'e2reinjectionEstimate', 'e5reinjectionActuals',
                    'e5reinjectionEstimate', 'e6reinjectionActuals', 'e6reinjectionEstimate'
                ].includes(col.field)) {
                    col.hide = false;
                }
            });
        }

        actualsViewON = !(actualsViewON)
        // No pinned footer in actuals view
        const pinnedBottomData = actualsViewON ? [] : footerItems
        nmntnColDef.map(col => {
            if ((!['id', 'commentsAssetLogistics', 'commentsBypass', 'date', 'facilityPipeline',
                'plannedOutage', 'product', 'unplannedOutage',
                'maxStorageM3', 'unit', 'updatedBy', 'updatedOn'].includes(col.field))
                && !(col.headerName.includes('Actuals'))) {
                col.hide = actualsViewON;
            }
            if (col.field === 'nominationNotMetReasons') {
                col.hide = actualsViewON
            }
        });

        this.state.gridOptions.api.setColumnDefs([]);
        this.state.gridOptions.api.setColumnDefs(nmntnColDef);
        this.state.gridOptions.api.setPinnedBottomRowData(pinnedBottomData);
        this.setState({
            nmntnColDef: nmntnColDef, actualsViewON: actualsViewON, assetViewON: false,
            overUnderViewON: false, nominationViewON: false, footerItems: footerItems
        });
    }

    exportToExcel = () => {
        var fileName = this.props?.selectedFacOption?.value
            + momenttimezone.tz(moment(new Date()), AppConstants.MT_TIME_FORMATTER)
                .format('_DDMMMYYYY_HHmmss');
        this.state.gridOptions.api.exportDataAsExcel({
            fileName: fileName,
            sheetName: moment(this.props?.selectedMnthOption).format('MMM-YYYY')
        });
    }

    exportE6ToExcel = async () => {
        const { CommonStore } = this.props
        const { assetViewON, overUnderViewON, nominationViewON, actualsViewON } = this.state
        let assetView = assetViewON
        let overUnderView = overUnderViewON
        let nomView = nominationViewON
        let actualView = actualsViewON

        /** 
         * - Disable the current selected view before triggering export all functionality
         * - When excel is exported and downloaded, enable the previously selected view
         * to display the same as user were seeing
        */
        if (assetView)
            this.assetView()
        if (overUnderView)
            this.overUnderView()
        if (nomView)
            this.nominationView()
        if (actualView)
            this.actualsView()
        CommonStore.toggleLoader()
        try {
            await this.getHiddenGridsData(this.props)
            const workbook = exportMultipleGrids(Object.assign({}, cloneDeep(this.state)))
            const filName = `E6Frac_ProdMonth${moment(this.props?.selectedMnthOption).format('YYYYMM')}`
            XLSX.writeFile(workbook, `${filName}.xlsx`, {
                bookType: 'xlsx', type: 'base64'
            })
        } catch (e) {
            console.log(e)
            window.toastr.error(AppConstants.TOASTER_ERROR_EXPORT)
        }
        if (assetView)
            this.assetView()
        if (overUnderView)
            this.overUnderView()
        if (nomView)
            this.nominationView()
        if (actualView)
            this.actualsView()
        CommonStore.toggleLoader()
    }

    getContextMenuItems = (params) => {
        var result = ['F1', 'F2', 'F3', 'F4'].includes(params.node.data.product) ? [] : [
            {
                name: 'Show Audit History',
                action: async () => {
                    this.auditLoad(params);
                },
            },
        ];
        return result;
    };
    processCellFromClipboard = (p) => {
        if (typeof p?.column?.colDef?.cellEditor != 'undefined'
            && p?.column?.colDef?.cellEditor === 'copyDownEditor') {
            if (typeof p?.column?.colDef?.cellEditorParams?.subType != 'undefined'
                && p?.column?.colDef?.cellEditorParams?.type !== null
                && p?.column?.colDef?.cellEditorParams?.subType !== null
                && (['positive', 'negative'].includes(p?.column?.colDef?.cellEditorParams?.subType)
                    || (p?.column?.colDef?.cellEditorParams?.type == 'Decimal'))) {
                if (typeof p.value != 'undefined' && p.value != null
                    && !isNaN(p.value.toString().replace(/,/g, '').replace('%', '')
                        .replace(String.fromCharCode(40), '-').replace(String.fromCharCode(41), ''))) {
                    let returnVal = Number(p.value.toString().replace(/,/g, '').replace('%', '')
                        .replace(String.fromCharCode(40), '-').replace(String.fromCharCode(41), ''));
                    if ((p?.column?.colDef?.cellEditorParams?.type === 'Decimal' && returnVal > 0)
                        || (p?.column?.colDef?.cellEditorParams?.subType === 'positive' && returnVal > 0)
                        || (p?.column?.colDef?.cellEditorParams?.subType === 'negative' && returnVal < 0)) {
                        return p.value;
                    }
                }
                return 0;
            }
        }
        return p.value;
    };
    auditLoad = async (params) => {
        let columnDef = this.state.nmntnColDef;
        let auditData = await NominationScreenStore.getNominationAudit({
            Date: params?.node?.data?.referrenceDate,
            Fact: this.props?.selectedFacOption?.value
        });
        if (Object.keys(auditData).length > 0) {
            auditData = auditData.filter((a) => {
                return columnDef.some((c) => {
                    if (a.fieldRef === c.field) { return a.fieldRef = c.headerName; }
                })
            });
            auditData = auditData.filter((a) => !["Unit", "Closing Tank Inventory Actuals",
                "Closing Tank Inventory Estimates"].includes(a.fieldRef));
            auditData.map((a) => {
                var val = a.trackChanges;
                if (!(typeof val == 'undefined' || val == null || val == '' || isNaN(val.toString()))) {
                    val = Number(val.toString());
                    var isNegative = (val < 0);
                    var text = Math.abs(val).toLocaleString(undefined, { minimumFractionDigits: 0 });

                    return a.trackChanges = (isNegative ? "(" + text + ")" : text);
                }
            });
            if (Object.keys(auditData).length > 0) {
                var selectedField =
                    columnDef.filter((f) => (f.field ===
                        params?.column?.userProvidedColDef.field))[0];
                this.setState({
                    auditOptions: [...new Set(auditData?.map(a => a.fieldRef))].sort(),
                    auditData: auditData, isAuditPopup: true,
                    auditSelectedField: {
                        label: selectedField?.headerName,
                        value: selectedField?.headerName
                    }
                });
            }
        }
    }
    auditLog = (option) => {
        this.setState({ isAuditPopup: option });
    }
    handleAuditFilter = (option) => {
        this.setState({ auditSelectedField: option });
    }
    render() {
        const { gridOptions, nmntnData, nmntnColDef, nominationRole,
            auditSelectedField, auditData, auditOptions, butaneColDefs,
            condensateColDefs, isoButaneColDefs, normalButaneColDefs, propaneColDefs,
            butaneData, condensateData, isoButaneData, normalButaneData,
            propaneData, butaneGridOptions, isoButaneGridOptions,
            normalButaneGridOptions, propaneGridOptions, condensateGridOptions
        } = this.state;
        const audit = (typeof auditSelectedField != 'undefined'
            && typeof auditSelectedField?.value != 'undefined'
            && auditSelectedField !== '') ? (auditData.filter((a) => a.fieldRef === auditSelectedField.value)) : [];

        const BI_REPORT_NOMINATION_URL = window.hostName.BI_REPORT_NOMINATION_URL;
        if (audit.length > 0) audit.reverse();

        return (
            <>
                <div className='nmntn-row'>
                    <AgGrid
                        gridOptions={gridOptions}
                        columnDefs={nmntnColDef}
                        rowData={nmntnData}
                        onCellValueChanged={this.onCellValueChanged.bind(this)}
                        onCellEditingStopped={this.onCellEditingStopped.bind(this)}
                        onPasteStart={this.onPasteStart.bind(this)}
                        onPasteEnd={this.onPasteEnd.bind(this)}
                    />
                </div>
                {
                    this.props.selectedFacOption?.value === 'NGL' ?
                        <>
                            <div
                                className='nmntn-row'
                                style={{ display: 'none', visibility: 'none' }}
                            >
                                <AgGrid
                                    gridOptions={butaneGridOptions}
                                    columnDefs={butaneColDefs}
                                    rowData={butaneData}
                                />
                                <AgGrid
                                    gridOptions={isoButaneGridOptions}
                                    columnDefs={isoButaneColDefs}
                                    rowData={isoButaneData}
                                />
                                <AgGrid
                                    gridOptions={normalButaneGridOptions}
                                    columnDefs={normalButaneColDefs}
                                    rowData={normalButaneData}
                                />
                                <AgGrid
                                    gridOptions={propaneGridOptions}
                                    columnDefs={propaneColDefs}
                                    rowData={propaneData}
                                />
                                <AgGrid
                                    gridOptions={condensateGridOptions}
                                    columnDefs={condensateColDefs}
                                    rowData={condensateData}
                                />
                            </div>
                        </> : null
                }
                <div className="nmntn-row nmntn-row-justify">
                    <div className="nmntn-left">
                        {
                            (
                                this.props.selectedFacOption?.value === 'AEGS' ||
                                this.props.selectedFacOption?.value === 'NGL' ||
                                this.props.selectedFacOption?.value === 'Propane' ||
                                this.props.selectedFacOption?.value === 'Butane' ||
                                this.props.selectedFacOption?.value === 'Iso-Butane' ||
                                this.props.selectedFacOption?.value === 'Normal Butane' ||
                                this.props.selectedFacOption?.value === 'Condensate' ||
                                (this.props.selectedFacOption?.value === 'TransCanada' && nominationRole === 'RO' ||
                                    this.props.selectedFacOption?.value === 'Foothills' && nominationRole === 'RO' ||
                                    this.props.selectedFacOption?.value === 'AEGS' && nominationRole === 'RO' ||
                                    this.props.selectedFacOption?.value === 'Kerrobert' && nominationRole === 'RO' ||
                                    this.props.selectedFacOption?.value === 'TransCanada' && nominationRole === 'OPS' ||
                                    this.props.selectedFacOption?.value === 'Foothills' && nominationRole === 'OPS' ||
                                    this.props.selectedFacOption?.value === 'AEGS' && nominationRole === 'OPS' ||
                                    this.props.selectedFacOption?.value === 'Kerrobert' && nominationRole === 'OPS' ||
                                    this.props.selectedFacOption?.value === 'NGL' && nominationRole === 'OPS' ||
                                    this.props.selectedFacOption?.value === 'Propane' && nominationRole === 'OPS' ||
                                    this.props.selectedFacOption?.value === 'Butane' && nominationRole === 'OPS' ||
                                    this.props.selectedFacOption?.value === 'Iso-Butane' && nominationRole === 'OPS' ||
                                    this.props.selectedFacOption?.value === 'Normal Butane' && nominationRole === 'OPS' ||
                                    this.props.selectedFacOption?.value === 'Condensate' && nominationRole === 'OPS')
                            ) &&
                            (nominationRole === 'ASSET' &&
                                (this.props.selectedFacOption?.value === 'TransCanada' ||
                                    this.props.selectedFacOption?.value === 'Kerrobert' ||
                                    this.props.selectedFacOption?.value === 'Foothills'
                                )
                            ) ||
                            (nominationRole === 'ASSET' ||
                                nominationRole === 'COMM' ||
                                nominationRole === 'OPS' ||
                                (this.props.selectedFacOption?.value === 'TransCanada' ||
                                    this.props.selectedFacOption?.value === 'Foothills' ||
                                    this.props.selectedFacOption?.value === 'AEGS' ||
                                    this.props.selectedFacOption?.value === 'Kerrobert' ||
                                    this.props.selectedFacOption?.value === 'NGL' ||
                                    this.props.selectedFacOption?.value === 'Propane' ||
                                    this.props.selectedFacOption?.value === 'Butane' ||
                                    this.props.selectedFacOption?.value === 'Iso-Butane' ||
                                    this.props.selectedFacOption?.value === 'Normal Butane' ||
                                    this.props.selectedFacOption?.value === 'Condensate' && nominationRole === 'RO')) &&
                            (
                                <button
                                    type="button"
                                    className="btn btn-primary nmntn-btn-text"
                                    onClick={this.assetView}
                                >
                                    <FontAwesomeIcon icon={faEye} /> Asset Team View
                                </button>
                            )
                        }

                        {
                            (
                                (nominationRole === "ASSET" ||
                                    nominationRole === "OPS" ||
                                    nominationRole === "COMM" ||
                                    (nominationRole === "RO" &&
                                        (this.props.selectedFacOption?.value === 'Foothills' ||
                                            this.props.selectedFacOption?.value === 'AEGS' ||
                                            this.props.selectedFacOption?.value === 'Kerrobert' ||
                                            this.props.selectedFacOption?.value === 'TransCanada' ||
                                            this.props.selectedFacOption?.value === 'AEGS' ||
                                            this.props.selectedFacOption?.value === 'Kerrobert' ||
                                            this.props.selectedFacOption?.value === 'NGL' ||
                                            this.props.selectedFacOption?.value === 'Propane' ||
                                            this.props.selectedFacOption?.value === 'Butane' ||
                                            this.props.selectedFacOption?.value === 'Iso-Butane' ||
                                            this.props.selectedFacOption?.value === 'Normal Butane' ||
                                            this.props.selectedFacOption?.value === 'Condensate')))
                            ) &&
                            (
                                <>
                                    <button
                                        type="button"
                                        className="btn btn-primary nmntn-btn-text"
                                        onClick={this.overUnderView}
                                    >
                                        <FontAwesomeIcon icon={faEye} /> Over/Under View
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary nmntn-btn-text"
                                        onClick={this.nominationView}
                                    >
                                        <FontAwesomeIcon icon={faEye} /> Nominations View
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary nmntn-btn-text"
                                        onClick={this.actualsView}
                                    >
                                        <FontAwesomeIcon icon={faEye} /> Actuals View
                                    </button>
                                </>
                            )

                        }
                        {
                            (this.props.selectedFacOption?.value === 'TransCanada' && nominationRole === "ASSET" ||
                                this.props.selectedFacOption?.value === 'TransCanada' && nominationRole === "RO" ||
                                this.props.selectedFacOption?.value === 'TransCanada' && nominationRole === "OPS") &&
                            (<a
                                href={BI_REPORT_NOMINATION_URL}
                                rel="noopener noreferrer"
                                target="_blank"
                                className="btn btn-primary nmntn-btn-text nomination-bi-report-btn"
                            >
                                <FontAwesomeIcon icon={faChartBar} /> BI Report - Border Flow and Bypass
                            </a>
                            )
                        }
                    </div>
                    <div className="nmntn-right">
                        {
                            this.props.selectedFacOption?.value === 'NGL' ?
                                <button
                                    type="button"
                                    className="btn btn-primary nmntn-btn-text"
                                    aria-expanded="false"
                                    onClick={this.exportE6ToExcel}
                                >
                                    <FontAwesomeIcon icon={faFileExport} /> Export All
                                </button>: null
                        }
                        <button
                            type="button"
                            className="btn btn-primary nmntn-btn-text"
                            aria-expanded="false"
                            onClick={this.exportToExcel}
                        >
                            <FontAwesomeIcon icon={faFileExport} /> Export
                        </button>
                    </div>
                </div>
                <div className="nmntn-modal-container">
                    <Modal show={this.state.isAuditPopup} size="xl">
                        <Form>
                            <Modal.Title>Audit History</Modal.Title>
                            <Modal.Body>
                                <div className='nmntn-row'>
                                    <div className="nmntn-div-style">Field Filter</div>
                                    <div className="nmntn-select-audit">
                                        <WindowedSelect
                                            onChange={this.handleAuditFilter}
                                            defaultValue={auditSelectedField}
                                            options={auditOptions.map((opt) => ({ label: opt, value: opt }))}
                                        />
                                    </div>
                                </div>
                                <div className="auditHistory-parent">
                                    <div className="auditHistory auditHistory-extn">
                                        <table id="tableHeader">
                                            <tbody>
                                                <tr ><th>Date</th><th>Field</th><th>Editor</th><th>Timestamp</th><th>Value</th></tr>
                                                {
                                                    audit?.map((a) => {
                                                        return (
                                                            <tr>
                                                                <td>{a.date}</td>
                                                                <td>{a.fieldRef}</td>
                                                                <td>{a.username}</td>
                                                                <td>{moment(a.timestamp).format('MM/DD/YYYY h:mm a')}</td>
                                                                <td>{a.trackChanges}</td>
                                                            </tr>)
                                                    })
                                                }
                                                {
                                                    (audit.length == 0) && (<tr><td colSpan="5">No Data Available</td></tr>)
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <button
                                    type="button"
                                    className="btn btn-primary "
                                    aria-expanded="false"
                                    onClick={() => this.auditLog(false)}
                                >
                                    Close
                                </button>
                            </Modal.Footer>
                        </Form>
                    </Modal>
                </div>
            </>
        )
    }
}
export default NominationData;